/* ****************************************************************************
Name:			  VPI New Inspection creation
**
** Desc:         This code is to create new VPI Inspection
** Author:        VAsu Pabbaraju
** Date:          2020/08/01

*******************************************************************************
**       CHANGE HISTORY
*******************************************************************************
**  Date			    Author					 Description
**  ----------  -----------------------  --------------------------------------
**  08/24/2020  Vasu Pabbaraju.           Commented Line number 1919-- to fix sublot issue - JIRA Number - Q360-353
**  10/23/2020  Vasu Pabbaraju.           Added Option to select dropdown LINE 2637 - to fix PO selection issue - JIRA Number - Q360-382
**  11/18/2020  Vasu Pabbaraju.           Added new plan details by part num, rev view end point  - JIRA Number - Q360-408
**  11/18/2020  Vasu Pabbaraju.           Changed Masetr Lot quantity default values - JIRA Number - q360-402
**  11/18/2020  Vasu Pabbaraju.           Changed Masetr Lot quantity default values to zero - JIRA Number - Q360-425
**  02/26/2021  Vasu Pabbaraju.           Added precsion to bonus tol calculation - JIRA Number - Q360-463
**  02/04/2022  Vasu Pabbaraju.           Removed * from packing slip - JIRA Number - Q360-597
******************************************************************************/ 


import React, { Fragment, useState, useEffect } from 'react';
import { withRouter } from "react-router-dom";
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { Breadcrumb, BreadcrumbItem, ButtonGroup } from 'reactstrap';
import moment from 'moment';
import 'moment-timezone';
import DataTable from 'react-data-table-component'

import classnames from 'classnames';
import Capability from './Capability';
import { Beforeunload } from 'react-beforeunload';
import { Typeahead } from 'react-bootstrap-typeahead';
import axios, { post } from 'axios';
import * as FileSaver from 'file-saver';
import SweetAlert from 'react-bootstrap-sweetalert';
import ReactGA, { set } from 'react-ga';
import config from '../../config/okta.config';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Nav, NavItem, NavLink, Modal, ModalHeader, ModalBody, ModalFooter, Progress, FormFeedback,Row,
  InputGroup, FormGroup, Label, Input, ButtonToggle, Spinner, UncontrolledTooltip, TabContent, TabPane
} from 'reactstrap';
import FileUploaderObj from './fileuploader'

import XLSX from 'xlsx';
import {
  Col,
  Card,
  CardBody, Button, InputGroupAddon
} from 'reactstrap';
import { Form, FormText } from 'reactstrap';
import { withAuth } from '@okta/okta-react';

import gql from 'graphql-tag';
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

const MAX_SAMPLE_UNITS = 102

var special_chars = /^[! @#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
// Update plan mutation config
require('react-datetime');
const UPDATE_REPORT = gql`
  mutation UpdateSupplierFile(
      $VendorNum: String
      $MasterLotNum: String
      $MasterLotQty: String
      $SubLotNum: String
      $SubLotQty: String
      $PartNum: String
      $Program: String
      $AgileDocIDVer: String
      $SupplierLogID: String
      $PONum: String
      $FileGUID: String
      $UpdateTS: String
      $factPlanID: Int
      $LoadTS: String
      $Status: String
      $ResetPlan: String
      $sampleUnits: Int
      $timeOrder: Int
      $PackingSlipNum: String
      $PartialShipmentFlag: Int
      $inspData: String
      $mstrLotCompletionDate: String
  ) {
    UpdateSupplierFile(input: {
        VendorNum:$VendorNum
        MasterLotNum: $MasterLotNum
        MasterLotQty: $MasterLotQty
        SubLotNum: $SubLotNum
        SubLotQty: $SubLotQty
        PartNum:$PartNum
        Program: $Program
        AgileDocIDVer:$AgileDocIDVer
        SupplierLogID:$SupplierLogID
        PONum:$PONum
        ResetPlan: $ResetPlan
        UpdateTS:$UpdateTS
        LoadTS:$LoadTS
        sampleUnits: $sampleUnits
        timeOrder: $timeOrder
        factPlanID:$factPlanID
        PackingSlipNum: $PackingSlipNum
        PartialShipmentFlag: $PartialShipmentFlag
        mstrLotCompletionDate: $mstrLotCompletionDate
        FileGUID:$FileGUID
        inspData:$inspData
        Status: $Status
    }) {
      iDetail {
        FileGUID

    }
    }
  }`;

//Get Supplier certificates call config
const GET_CERTIFICATES = gql`
  query getCertificates($FileGUID: String){
    SupplierCertificates(filters: {
      FileGUID: $FileGUID
}) {
 edges {
   node {
    FileGUID
    FileName
    FileLocation
    LoadTS
    UpdateTS
    SupplierLogID
   }
 }
}
}

`;

//Get Inspections for a given PO,Part, Doc Version
const GET_INSPECTIONS = gql`
      query getInspections($VendorNum: String, $PartNum: String, $AgileDocIDVer: String){
        SupplierFileHeader(filters: {
          VendorNum: $VendorNum
          PartNum: $PartNum
          AgileDocIDVer: $AgileDocIDVer
    }) {
     edges {
       node {
         PartNum
         AgileDocIDVer
         MasterLotQty
         PONum
         Status
         FileGUID
         UpdateTS
         MasterLotNum
         mstrLotCompletionDate
         factPlanID
       }
     }
    }
  }

  `;

//Create a new report mutation config
const CREATE_REPORT = gql`
    mutation SupplierFileHeader(
       $VendorNum: String
       $MasterLotNum: String
       $MasterLotQty: Int
       $SubLotNum: String
       $SubLotQty: Int
       $PartNum: String
       $AgileDocIDVer: String
       $Program: String
       $SupplierLogID: String
       $PONum: String
       $FileGUID: String
       $UpdateTS: String
       $factPlanID: Int
       $LoadTS: String
       $Status: String
       $sampleUnits: Int
       $timeOrder: Int
       $PackingSlipNum: String
       $PartialShipmentFlag: Int
       $DetailString: String
       $mstrLotCompletionDate: String
       $MeasurementsProvided: Int
    ) {
      SupplierFileHeader(input:{
    VendorNum:$VendorNum
    MasterLotNum: $MasterLotNum
    MasterLotQty: $MasterLotQty
    SubLotNum: $SubLotNum
    SubLotQty: $SubLotQty
    PartNum:$PartNum
    Program: $Program
    AgileDocIDVer:$AgileDocIDVer
    SupplierLogID:$SupplierLogID
    PONum:$PONum
    FileGUID:$FileGUID
    UpdateTS:$UpdateTS
    LoadTS:$LoadTS
    Status: $Status
    sampleUnits: $sampleUnits
    timeOrder: $timeOrder
    PackingSlipNum: $PackingSlipNum
    PartialShipmentFlag: $PartialShipmentFlag
    DetailString:$DetailString
    factPlanID:$factPlanID
    mstrLotCompletionDate: $mstrLotCompletionDate
    MeasurementsProvided: $MeasurementsProvided
  }){
    iHeader {
      FileGUID
      Status
      MeasureLotFlag
    }
  }
}`;


// Get Report Header call config
const GET_REPORT_HEADER = gql`
      query getReportHeader($FileGUID: String){
        SupplierFileHeader(filters: {
           FileGUID:$FileGUID
    }) {
     edges {
       node {
         PartNum
         MasterLotNum
          MasterLotQty
          SubLotNum
          SubLotQty
         AgileDocIDVer
         PONum
         Status
         FileGUID
         Program
         sampleUnits
         timeOrder
         mstrLotCompletionDate
         PartialShipmentFlag
         PackingSlipNum
         MeasureLotFlag
         MasterLotQty
         factPlanID

       }
     }
    }
  }
`;

//Get PPQP Details call config
const GET_FILE_VALIDATION_DETAILS = gql`
      query getFileValidationDetails($FileGUID: String){
        SupplierFileValidation(filters:{
    FileGUID:$FileGUID
  }) {
    edges {
      node {
        FileGUID
        FEATURE
        LABEL
        ColIndex
        AvgVal
        PPKSd
        LSL
        USL
        CPKMssd
        CPKSd
        PPKCpl
        PPKCpu
        CPKCpl
        CPKCpu
        SampleSize
        SubGrpCount
        ColSlNum
        LabelNum
        LoadTS
        NLRuleMetFlag
        NLLclMr
        NLLclI
        NLUclI
        NLStdevmr
        NLMravg
        spcSampleSizeMetFlag
        spcMinSubGrpsMetFlag
        ProcessCpblSamplesizeMetFlag
        Capability
        SpecCheck
        Normality
        pValue
        ADpValue
        CPK
        PPK

      }
    }
  }
  }
`;

//Get Report details call config
const GET_REPORT_DETAIL = gql`
      query getReportDetail($FileGUID: String){
        SupplierFileDetails(filters: {
           FileGUID:$FileGUID
    }) {
     edges {
       node {
         UnitNo
          Label
          LabelNum
          ColIndex
          ColSlNum
          Val
          FileGUID
          LoadTS,
          samplingTime,
          subGroup
          bonus
          cavityID
          
       }
     }
    }
  }
`;

//Get List of Open PO for the vendor Config
const GET_OPEN_PO = gql`
      query getOpenPO($VendorNum: String, $OpenPOFlag:String){
        SupplierPO(filters: {
           VendorNum:$VendorNum
           OpenPOFlag: $OpenPOFlag
    }) {
     edges {
       node {
         PONum
         MaterialNum
         MaterialRev
         POQty 
         RcvdQty
       }
     }
    }
  }
`;

//Get Plan  by Part Number and Revision
const GET_PLANS = gql`
      query vwApp1factplan($PartNum: String, $PartRev: String) {
        vwApp1factplan(
          filters :{
            PartNum: $PartNum
            PartRev:$PartRev
            DelFlag:"0"
            Approved:"true"
          }
        ) {
          edges {
            node {
              PartNum
              PartRev
              PlanID
              DraftMode
              Released
              Approved
              VersionNumDescOrd
              
            }
          }
        }
      }
`;



//Get Plan Details by Part Number and Revision
const GET_PLAN_DETAILS_PART = gql`
query getPlanDetails($PlanID: String){
      searchPlans(q:$PlanID) {
        __typename
        ... on  vw_App1FactPlanSpecsByPartRev {
      PartNum
      PartRev
      SpecId
      PlanID
      Label
      LabelNum
      Method
      Method2
      LSL
      USL
      Precision
      Sampling
      AQL
      ColIndex
      ColSlNum
      Characteristic
      SpecType
      SpecVal
      SpecValMin
      SpecValMax
      SpecValTOLPlus
      SpecValTOLMinus
      INSTRUCTIONS
      BaloonNum
      VersionNumDescOrd
      SpecDataType
      }

}
  }
`;

// //Get Plan Details by Part Number and Revision
// const GET_PLAN_DETAILS_PART = gql`
//       query vwApp1factplanspecsbypartrev($PlanID: String){
//         vwApp1factplanspecsbypartrev(filters: {
//            PlanID:$PlanID
//     },sort:COL_SL_NUM_ASC) {
//      edges {
//        node {
//          PlanID
//          SpecId
//          Label
//          LabelNum
//          Method
//          LSL
//          USL
//          SpecDataType
//          Precision
//          ColIndex
//          ColSlNum
//          Sampling
//          AQL
//          Characteristic
//          SpecType
//          SpecVal
//          SpecValMin
//          SpecValMax
//          SpecValTOLPlus
//          SpecValTOLMinus
//          BonusTOL
//          NumPlaces
       
//          SheetNum
//        }
//      }
//     }
//   }
// `;


//Get Plan Details by Part Number and Revision
const GET_PLAN_DETAILS = gql`
query getPlanDetails($PlanID: String){
  searchPlans(q:$PlanID) {
    __typename
    ... on  vw_App1FactPlanSpecsByPartRev {
  PartNum
  PartRev
  SpecId
  PlanID
  Label
  LabelNum
  Method
  Method2
  LSL
  USL
  Precision
  Sampling
  AQL
  ColIndex
  ColSlNum
  Characteristic
  SpecType
  SpecVal
  SpecValMin
  SpecValMax
  SpecValTOLPlus
  SpecValTOLMinus
  INSTRUCTIONS
  BaloonNum
  VersionNumDescOrd
  SpecDataType
  }

}
  }
`;



//Get Supplier certificates call config
const GET_LOTS = gql`
query GetLots($FileGUID: String) {
  vwAppinspectionlotnew(filters:{
    FileGUID: $FileGUID
  }) {
    edges {
      node {
        ILNum
      }
    }
  }
}
`;

const FIND_PO = gql`
query getPO($PONum: String, $VendorNum: String){
  vwItem(filters:{
    PONum:$PONum
    VENDORIlike:$VendorNum
  }) {
    edges {
      node {
        PONum
        POItemNum
        PLANT
        MATERIAL
        REVLevel
        POCreatedBy
        POQuantity
        OPENQuantity
        GOODSReceivedQuantity
        REQUISITIONEr
        MATERIALType
        DELETIONIndicator
        PURCHASINGGroup
      }
    }
  }
}
`;
// poitems_with_purchasing_groups

const GET_PURCHASING_GROUPS = gql`
query getvwPurchasingGroups($PURCHASINGGroup: String) {
  vwPurchasingGroups(filters:{
    PURCHASINGGroup:$PURCHASINGGroup
  }) {
    edges {
      node {
        CLIENT
        PURCHASINGGroup
        PURCHASINGGroupDesc
        PHONENumber
        OUTPUTDevice
        # FAX_NUMBER
        # DIAL_CODE_TEL_NUMBER
        # PHONE_EXTENSION
        # SMTP_ADDRESS
        # DW_LAST_UPDATE_TS
      }
    }
  }
}
`;



const BLANK_PLAN_ID = -999999999


//Start main code
const NewReport = ({ history }) => {


  //Declare state variables
  const [planDetails, setPlanDetails] = useState(null);
  const [planDetailsList, setPlanDetailsList] = useState(null);
  const [header, setHeader] = useState(null);
  const [details, setDetails] = useState(null);
  const [submitEnabled, setSubmitEnabled] = useState(false);
  const [reportMode, setReportMode] = useState("");
  const [reportFileGUID, setReportFileGUID] = useState(null);
  const [SupplierFileHeader] = useMutation(CREATE_REPORT);
  const [UpdateSupplierFile] = useMutation(UPDATE_REPORT);

  const [packingSlip, setPackingSlip] = useState(null);
  const[purchaseOrderNumberValid, setPurchaseOrderNumberValid] = useState(false);
  const [PONum, setPONum] = useState(null);
  const [PartNum, setPartNum] = useState(null);
  const [AgileDocIDVer, setAgileDocIDVer] = useState(null);
  const [MasterLotNum, setMasterLotNum] = useState(null);
  const [mstrLotCompletionDate, setMstrLotCompletionDate] = useState(null);
  const [MasterLotQty, setMasterLotQty] = useState(null);
  const [SubLotNum, setSubLotNum] = useState(null);
  const [SubLotQty, setSubLotQty] = useState(null);
  const [sampleUnits, setSampleUnits] = useState(null);
  const [openPO, setOpenPO] = useState('');
  const [selectedPO, setSelectedPO] = useState(null);
  const [POMaterial, setPOMaterial] = useState([]);
  const [MaterialRev, setMaterialRev] = useState([]);
  const [newreportBtn, setNewReportBtn] = useState(false);
  const [showSaveConfirmation, setShowSaveConfirmation] = useState(false);
  const [showSubmitConfirmation, setShowSubmitConfirmation] = useState(false);
  const [showLoading, setShowLoading] = useState(null);
  const [, setValidationData] = useState(null);
  const [showFinalReport, setShowFinalReport] = useState(false);
  const Datetime = require('react-datetime');
  const [mandatorValidation, setMandatoryValidation] = useState(null);
  const [inspections, setInspections] = useState(null);
  const [masterQtyDisable, setMasterQtyDisable] = useState(false);
  const [activeTab, setActiveTab] = useState('1');
  const [showPlanDoesNotExist, setShowPlanDoesNotExist] = useState(null);
  const [, setShowDashboard] = useState(null);
  const [, setChart1Options] = useState([]);
  const [] = useState(null);
  const [timeOrdered, setTimeOrdered] = useState(false);
  const [partialShipment, setPartialShipment] = useState(false);
  const [measurementsExist, setMeasurementsExist] = useState(true);
  const [certFiles, setCertFiles] = useState(null);
  const [certsArray, setCertsArray] = useState(null);
  const [certificates, setCertificates] = useState(null);
  const [showFileUpload, setShowFileUpload] = useState(false);
  const [subgroupSize, setSubGroupSize] = useState(null);
  const [subgroupsizeText, setSubgroupsizeText] = useState(null);
  const [subgroupSizeValidated, setSubGroupSizeValidated] = useState(false);
  const [unitsValidated, setUnitsValidated] = useState(false);
  const [showMasterLotQtyError, setShowMasterLotQtyError] = useState(false);
  const [sampleTimeValidated, setSampleTimeValidated] = useState(false);
  // const SweetAlert = withSwalInstance(swal);
  const [showReset, setShowReset] = useState(false);
  const [MaterialOpenPO, setMaterialOpenPO] = useState([]);
  const [showValidatePlan, setShowValidatePlan] = useState(false);
  const [planError, setPlanError] = useState(false);
  const [measureLotFlag, setMeasureLotFlag] = useState(null);
  const [showPlanChange, setShowPlanChange] = useState(false);
  const [factPlanID, setFactPlanID] = useState(false);
  const [showFeatureMapping,setShowFeatureMapping] = useState(false);
  const [featureDataMapping,setFeatureDataMapping] = useState(false);
  const [planTemplate,setPlanTemplate] =  useState('ISI');
  const [lots,setLots] = useState(null);
 const [invalidMasterLot, setInvalidMasterLot] = useState(false);
 const [measurementsUpload, setMeasurementsUpload] = useState(true);
 const [foundPO, setFoundPO] = useState(false);
 const [POData, setPOData] = useState(null);
 const [showNoPOFoundMessage, setShowNoPOFoundMessage] = useState(false);
 const [showCheckSubmitConfirmation, setShowCheckSubmitConfirmation] = useState(false);
  const [certSpecs, setCertSpecs] = useState(null);
  const [computerVisionEnabled, setComputerVisionEnabled] = useState(false);
  const [computerVisionAPICompleted, setComputerVisionAPICompleted] = useState(true);
  const [requirementsList, setSetRequirementsList] = useState([]);
  const [selectedCertRequirements, setSelectedCertRequirements] = useState([]);
  const [certRequirementsSatisfied, setCertRequirementsSatisfied] = useState(false);
  const [planDetailsApiCompleted, setPlanDetailsApiCompleted] = useState(false);
  const [purchasingGroups, setPurchasingGroups] = useState([]);

 const poColumns = [
  {
    name: 'PO Number',
    selector: 'node.PONum',
    sortable: true,
    style: {
      color: '#202124',
      fontSize: '13px',
      fontWeight: 500,
    },
  },{
    name: 'PO Item Number',
    selector: 'node.POItemNum',
    sortable: true,
    style: {
      color: '#202124',
      fontSize: '13px',
      fontWeight: 500,
    },
  },{
    name: 'Plant',
    selector: 'node.PLANT',
    sortable: true,
    style: {
      color: '#202124',
      fontSize: '13px',
      fontWeight: 500,
    },
  },{
    name: 'Material',
    selector: 'node.MATERIAL',
    sortable: true,
    style: {
      color: '#202124',
      fontSize: '13px',
      fontWeight: 500,
    },
  },{
    name: 'Revision',
    selector: 'node.REVLevel',
    sortable: true,
    style: {
      color: '#202124',
      fontSize: '13px',
      fontWeight: 500,
    },
  },{
    name: 'PO Requester',
    // selector: 'node.REQUISITIONEr',
    //  selector: 'node.PURCHASINGGroup',
    cell: row => 
       (row.node.REQUISITIONEr.length === 0) ? <div>
        {purchasingGroups.map((pg) => {
          if (pg.node.PURCHASINGGroup === row.node.PURCHASINGGroup) {
            return pg.node.PURCHASINGGroupDesc
          }
        }
        )}
        </div> : <div>
          {row.node.REQUISITIONEr}
          </div>
        ,  
    // PURCHASING_GROUP
    sortable: true,
    style: {
      color: '#202124',
      fontSize: '13px',
      fontWeight: 500,
    },
  },{
    name: 'PO Quantity',
    selector: 'node.POQuantity',
    sortable: true,
    style: {
      color: '#202124',
      fontSize: '13px',
      fontWeight: 500,
    },
  },{
    name: 'Goods Received Quantity',
    selector: 'node.GOODSReceivedQuantity',
    sortable: true,
    style: {
      color: '#202124',
      fontSize: '13px',
      fontWeight: 500,
    },
  },{
    name: 'Open Quantity',
    selector: 'node.OPENQuantity',
    sortable: true,
    style: {
      color: '#202124',
      fontSize: '13px',
      fontWeight: 500,
    }
  },
  {
    name: 'Deletion Indicator for PO Item ',
    // selector: 'node.DELETIONIndicator',
    cell: row => 
    // (!row.node.DELETIONIndicator && row.node.DELETIONIndicator.length === 0 ? <div>yes</div> : <div>No (   {row.node.DELETIONIndicator} )</div>),  
    ( row.node.DELETIONIndicator.length !== 0 ? <div>yes</div> : <div>No</div>),  
    sortable: true,
    style: {
      color: '#202124',
      fontSize: '13px',
      fontWeight: 500,
    }
    }
    ,{
      name: '',
      cell: row =>  (row.node.OPENQuantity>0 && row.node?.REVLevel !== "")? <Button disabled={ row.node.DELETIONIndicator.length !== 0 } color="primary" size="sm" onClick={() => selectPO(row.node)}>Select</Button> : null,
      // cell: row =>  (row.node.OPENQuantity>0 && row.node?.REVLevel !== "")? <Button disabled={row.node && row.node.MATERIALType === 'ZFRT' ? true : false} color="primary" size="sm" onClick={() => selectPO(row.node)}>Select</Button> : null,
      sortable: true,
      style: {
        color: '#202124',
        fontSize: '13px',
        fontWeight: 500,
      },
   
  }
  // ,{
  //   name: '',
  //   cell: row => (row.node && row.node.MATERIALType === 'ZFRT') ? (
  //     <div style={{ color: 'red', fontSize: '11px', fontWeight: 500 }}>
  //       Not a Valid PO.<br/> It's a finished goods part.
  //     </div>
  //   ) : null,
  // }
];

  const selectPO = (data) => {
    setSelectedPO(data.PONum);
    setPONum(data.PONum);
    setShowNoPOFoundMessage(false);
    setFoundPO(true);
    setPartNum(data.MATERIAL);
    setAgileDocIDVer(data.REVLevel);
   
    setMandatoryValidation(true);
    getPlans({
      variables: {
        PartNum: data.MATERIAL,
        PartRev: data.REVLevel
      }
    });
  }

  const validateAndSetPONum = (value) => {
    var reg = new RegExp('^\\d+$');
    if (reg.test(value)) {
      // Check if the value starts with 45, 55, or 80
      if (value.startsWith('21') || value.startsWith('45') || value.startsWith('55') || value.startsWith('80') || value.startsWith('70')) {
        setPurchaseOrderNumberValid(true);
        console.log('Only POs starting from 21*, 45*, 55*, 70* or 80* are allowed for submission in VPI')
      } else {
        setPurchaseOrderNumberValid(false);
      }
    } else {
      setPurchaseOrderNumberValid(false);
    }
    setPONum(value);
  }

  const clearAll = () => {
    setSelectedPO(null);
    setPONum('');
    setPartNum(null);
    setAgileDocIDVer(null);
    setMasterLotNum(null);
    setMasterLotQty(null);
    setSubLotNum(null);
    setSubLotQty(null);
    setSampleUnits(null);
    setPackingSlip(null);
    setFoundPO(false);
    setPOData(null);
    setMstrLotCompletionDate(null);
    setPlanDetailsApiCompleted(false);
    setPlanDetails(null)

  }

  const doesPOHaveMaterialsWithOpenQty = () => {
    if (POData) {
      const sumOfQty = POData.reduce((acc, material) => acc + material.node.OPENQuantity, 0)
      return sumOfQty > 0
    } else {
      return false
    }
  }

  //Check if there is a fileguid in the history
  let fileGuid = '';
  if (history.location.FileGUID) {
    if (history.location.FileGUID == 'new') {
      fileGuid = null;
    } else {
      fileGuid = history.location.FileGUID;

    }
  } else { //Get it from localstorage
    fileGuid = localStorage.getItem('selectedFile');
  }

  /******* Helper functions to make API Calls */

  // Get list of OPEN PO for the logged in vendor
  const { data } = useQuery(GET_OPEN_PO, {
    fetchPolicy: 'no-cache',
    variables: { VendorNum: localStorage.getItem('loggedInVendor'), 'OpenPOFlag': '1' }
  });

      //Get List of certificates 
  const [GetInspectionLots] = useLazyQuery(GET_LOTS, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
        
        
          setLots(data.vwAppinspectionlotnew.edges);
          // setRefresh(new Date());
          // options['certificates'] = data.SupplierCertificates.edges;
        },
        onError: (error) => {
          console.log(error)
        }
      });

  const [getPO] = useLazyQuery(FIND_PO, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
          if (data.vwItem.edges.length > 0) {
            const purchasingGroups_tmp = new Set();
            data.vwItem.edges.forEach((po) => {
              purchasingGroups_tmp.add(po.node.PURCHASINGGroup);
            });
            purchasingGroups_tmp.forEach((pg) => {
              getvwPurchasingGroups({ variables: { PURCHASINGGroup: pg } });
            });
            setPOData(data.vwItem.edges);
            setShowNoPOFoundMessage(false);
          } else {
            setFoundPO(false);
            setPOData(null);
            setShowNoPOFoundMessage(true);
          }
          setShowLoading(false);
        },
        onError: (error) => {
          console.log(error)
          setShowLoading(false);
        }
      });

      const [getvwPurchasingGroups] = useLazyQuery(GET_PURCHASING_GROUPS, {
        fetchPolicy: 'no-cache',
        onCompleted: (data) => {
          if (data.vwPurchasingGroups.edges.length > 0) {
            setPurchasingGroups(data.vwPurchasingGroups.edges);
            console.log('purchase groups: ',data)
          } else {
            console.log('purchase groups not found')
          }
        },
        onError: (error) => {
          console.log(error)
        }
      });

  

  //Get List of certificates 
  const [getCertificates] = useLazyQuery(GET_CERTIFICATES, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setCertificates(data.SupplierCertificates.edges);
      if ((details && !(measurementsUpload && !planDetails) && certificates) || (header && header['factPlanID'] === BLANK_PLAN_ID)) {
        validateAllUnits();
      }
    }
  });

  //Get Inspections
  const [getInspections] = useLazyQuery(GET_INSPECTIONS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setInspections(data.SupplierFileHeader.edges);

    }
  });

  //Get Report Header Details and populate state objects and local variables
  const [getReportHeader] = useLazyQuery(GET_REPORT_HEADER, {
    fetchPolicy: 'no-cache',
    onCompleted: (rhdata) => {
      let headerObject = {};
      if (rhdata.SupplierFileHeader.edges.length > 0) {
        headerObject['PartNum'] = rhdata.SupplierFileHeader.edges[0].node.PartNum;
        headerObject['AgileDocIDVer'] = rhdata.SupplierFileHeader.edges[0].node.AgileDocIDVer;
        headerObject['PONum'] = rhdata.SupplierFileHeader.edges[0].node.PONum;
        headerObject['MasterLotNum'] = rhdata.SupplierFileHeader.edges[0].node.MasterLotNum;
        headerObject['MasterLotQty'] = rhdata.SupplierFileHeader.edges[0].node.MasterLotQty;
        headerObject['SubLotNum'] = rhdata.SupplierFileHeader.edges[0].node.SubLotNum;
        headerObject['SubLotQty'] = rhdata.SupplierFileHeader.edges[0].node.SubLotQty;
        headerObject['sampleUnits'] = (rhdata.SupplierFileHeader.edges[0].node.MeasureLotFlag) ? rhdata.SupplierFileHeader.edges[0].node.sampleUnits : 0;
        headerObject['timeOrder'] = rhdata.SupplierFileHeader.edges[0].node.timeOrder;
        headerObject['PartialShipmentFlag'] = rhdata.SupplierFileHeader.edges[0].node.PartialShipmentFlag;
        headerObject['PackingSlipNum'] = rhdata.SupplierFileHeader.edges[0].node.PackingSlipNum;
        headerObject['mstrLotCompletionDate'] = rhdata.SupplierFileHeader.edges[0].node.mstrLotCompletionDate;
        headerObject['Program'] = rhdata.SupplierFileHeader.edges[0].node.Program;
        headerObject['Status'] = rhdata.SupplierFileHeader.edges[0].node.Status;
        headerObject['measureLotFlag'] = rhdata.SupplierFileHeader.edges[0].node.MeasureLotFlag;
        headerObject['factPlanID'] = rhdata.SupplierFileHeader.edges[0].node.factPlanID;
        // headerObject['acceptreject'] = document.getElementById('acceptreject').value;

        setHeader(headerObject);

        if (rhdata.SupplierFileHeader.edges[0].node.PONum != '') {
          setPONum(rhdata.SupplierFileHeader.edges[0].node.PONum);
        }
        if (rhdata.SupplierFileHeader.edges[0].node.MasterLotNum != '') {
          setMasterLotNum(rhdata.SupplierFileHeader.edges[0].node.MasterLotNum);
        }
        if (rhdata.SupplierFileHeader.edges[0].node.MasterLotQty != '') {
          setMasterLotQty(rhdata.SupplierFileHeader.edges[0].node.MasterLotQty);
        }
        if (rhdata.SupplierFileHeader.edges[0].node.SubLotNum != '') {
          setSubLotNum(rhdata.SupplierFileHeader.edges[0].node.SubLotNum);
        }
        if (rhdata.SupplierFileHeader.edges[0].node.SubLotQty != '') {
          setSubLotQty(rhdata.SupplierFileHeader.edges[0].node.SubLotQty);
        }
        if (rhdata.SupplierFileHeader.edges[0].node.PartNum != '') {
          setPartNum(rhdata.SupplierFileHeader.edges[0].node.PartNum);
        }

        if (rhdata.SupplierFileHeader.edges[0].node.PartialShipmentFlag != '') {
          setPartialShipment(rhdata.SupplierFileHeader.edges[0].node.PartialShipmentFlag);
        }
        if (rhdata.SupplierFileHeader.edges[0].node.PackingSlipNum != '') {
          setPackingSlip(rhdata.SupplierFileHeader.edges[0].node.PackingSlipNum);
        }
        if (rhdata.SupplierFileHeader.edges[0].node.Program != '') {
          setSubGroupSize(rhdata.SupplierFileHeader.edges[0].node.Program);
        }

        if (rhdata.SupplierFileHeader.edges[0].node.AgileDocIDVer != '') {
          setAgileDocIDVer(rhdata.SupplierFileHeader.edges[0].node.AgileDocIDVer);
        }
        if (rhdata.SupplierFileHeader.edges[0].node.Status != '') {
          setReportMode(rhdata.SupplierFileHeader.edges[0].node.Status);
        }

        if (rhdata.SupplierFileHeader.edges[0].node.sampleUnits != '') {
          setSampleUnits(rhdata.SupplierFileHeader.edges[0].node.sampleUnits);
        }

        if (rhdata.SupplierFileHeader.edges[0].node.mstrLotCompletionDate != '') {
          setMstrLotCompletionDate(rhdata.SupplierFileHeader.edges[0].node.mstrLotCompletionDate);
        }

        if (rhdata.SupplierFileHeader.edges[0].node.factPlanID != '') {
          setFactPlanID(rhdata.SupplierFileHeader.edges[0].node.factPlanID);
        }

        if (rhdata.SupplierFileHeader.edges[0].node.MeasureLotFlag == 1) {
          setMeasureLotFlag(true);
        } else {
          setMeasureLotFlag(false);
        }

        if (rhdata.SupplierFileHeader.edges[0].node.timeOrder == 1) {
          setTimeOrdered(true);
        } else {
          setTimeOrdered(false);
        }

        //Get Plan Details for the part and revision

        ////console.log(rhdata.SupplierFileHeader.edges[0]);
        getPlanDetailsData({
          variables: {
            PlanID: rhdata.SupplierFileHeader.edges[0].node.factPlanID
          }
        });

        //Get report details for the file Guid
        getReportDetail({ variables: { FileGUID: reportFileGUID } });
      } else {
        setPlanError(true);
      }
    }
  });

  //Get Report Details call
  const [getReportDetail] = useLazyQuery(GET_REPORT_DETAIL, {
    fetchPolicy: 'no-cache',
    onCompleted: (rddata) => {
      let tdetails = [];
      // document.getElementById('loadingdiv').style.display = 'none';
      rddata.SupplierFileDetails.edges.map((el) => {
        let detailObject = {};
        detailObject['UnitNo'] = el.node['UnitNo'];
        detailObject['Label'] = el.node['Label'];
        detailObject['LabelNum'] = el.node['LabelNum'];
        detailObject['Sampling'] = el.node['Sampling'];
        detailObject['InspectionMethod'] = el.node['InspectionMethod'];
        detailObject['ColIndex'] = el.node['ColIndex'];
        detailObject['ColSlNum'] = el.node['ColSlNum'];
        detailObject['samplingTime'] = el.node['samplingTime'];
        detailObject['subGroup'] = parseInt(el.node['subGroup']);
        detailObject['Val'] = el.node['Val'];
        detailObject['bonus'] = el.node['bonus'];
        detailObject['cavityID'] = el.node['cavityID'];
        detailObject['FileGUID'] = el.node['FileGUID'];
        detailObject['UpdatedTime'] = el.node['UpdatedTime'];
        detailObject['DWLoadTS'] = el.node['DWLoadTS'];
        tdetails.push(detailObject);
      });

      // If the report is time ordered, pre populate subgroup data 
      if (timeOrdered) {
        setSubgroupData(tdetails, header);
      }

      //Set detal data state
      // setDetails(tdetails);
      updateInspectionCache(reportFileGUID,tdetails,'initial', 'new');
      
    }
  });

  //Get PPQP details call
  const [getFileValidationDetails] = useLazyQuery(GET_FILE_VALIDATION_DETAILS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      let tValidationData = [];
      data.SupplierFileValidation.edges.map((el) => {
        let tValObject = {};
        tValObject['FEATURE'] = el.node.FEATURE;
        tValObject['pValue'] = el.node.pValue;
        tValObject['CPK'] = el.node.CPK;
        tValObject['PPK'] = el.node.PPK;

        if (el.node.pValue > 0.05) {
          tValObject['Normality'] = 'Normal';
        } else {
          tValObject['Normality'] = 'Non-Normal';
        }

        tValidationData.push(tValObject);
      });

      setValidationData(tValidationData);
      setShowLoading(false);
      setShowDashboard(true);
    }
  });


   //Get Plan details call
   const [getPlans] = useLazyQuery(GET_PLANS, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
        if (data.vwApp1factplan.edges && data.vwApp1factplan.edges.length > 0) {
          data.vwApp1factplan.edges.map((el,i) => {
            if (el.node.VersionNumDescOrd == 1) {
            getPlanDetailsByPartData({ variables: { PlanID:el.node.PlanID } });
            }
          });
            
          
        } else {
          setPlanDetailsApiCompleted(true);
        }
    }
  });

   //Get Plan details call
   const [getPlanDetailsByPartData] = useLazyQuery(GET_PLAN_DETAILS_PART, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setPlanDetailsApiCompleted(true);
      setShowLoading(false);
      console.log(data)
      if (data.searchPlans.length > 0) {
        setPlanDetails(data.searchPlans);
        let tplanDetailsList = [];
        data.searchPlans.map((el,i) => {
              tplanDetailsList.push(el);
              //console.log(el.node)
          });
          setPlanDetailsList([...tplanDetailsList]);
          console.log(tplanDetailsList)
          let tcertspecs = tplanDetailsList.filter(pdata => pdata.SpecDataType == 'Attribute');
          setCertSpecs(tcertspecs);

         


        if (header) {
          let tHeader = header;
          if (data.searchPlans.length > 0) {
            tHeader['partDesc'] = data.searchPlans.PartDesc;
            setHeader(tHeader);
          } else {
            setPlanError(true);
          }
        }
        if (document.getElementById('NewReportBtn')) {
          document.getElementById('NewReportBtn').style.display = 'block';
        }
        setShowPlanDoesNotExist(false);
        setShowValidatePlan(false);
      } else {
        setShowPlanDoesNotExist(true);
        setShowValidatePlan(false);
        // document.getElementById('NewReportBtn').style.display = 'none';
      }
    }
  });


  //Get Plan details call
  const [getPlanDetailsData] = useLazyQuery(GET_PLAN_DETAILS_PART, {
    fetchPolicy: 'no-cache',
    onCompleted: (data) => {
      setShowLoading(false);
      if (data.searchPlans.length > 0) {

        setPlanDetails(data.searchPlans);

        let tplanDetailsList = [];
        data.searchPlans.map((el,i) => {
              tplanDetailsList.push(el);
              //console.log(el.node)
          });
          console.log(tplanDetailsList)
          setPlanDetailsList([...tplanDetailsList]);
          let tcertspecs = tplanDetailsList.filter(pdata => pdata.SpecDataType == 'Attribute');
          setCertSpecs(tcertspecs);



        if (header) {
          let tHeader = header;
          if (data.searchPlans.length > 0) {
            tHeader['partDesc'] = data.searchPlans[0].PartDesc;
            setHeader(tHeader);
          } else {
            setPlanError(true);
          }
        }
        if (document.getElementById('NewReportBtn')) {
          document.getElementById('NewReportBtn').style.display = 'block';
        }
        setShowPlanDoesNotExist(false);
        setShowLoading(false);
        setShowValidatePlan(false);
      } else {
        setShowPlanDoesNotExist(true);
        setShowValidatePlan(false);
        // document.getElementById('NewReportBtn').style.display = 'none';
      }
    }
  });

  /**** end of functions for API Calls */

  //Subgrop generation for time oredered reports
  const setSubgroupData = (tdetails, hData) => {

    let sgroupsize = Number(hData['Program']);

    let sgrp = 1
    let counter = 1;

    for (var units = 0; units < Number(hData['sampleUnits']); units++) {
      tdetails.map((el, i) => {
        if (Number(el['UnitNo']) == (units + 1)) {
          if (isNaN(el['subGroup']) || el['subGroup'] == null || el['subGroup'] == 'null') {
            el['subGroup'] = sgrp;
            el['dirty'] = true;
          }
        }
      });
      counter++;
      if (counter > sgroupsize) {
        counter = 1;
        sgrp++;
      }
    }
    return tdetails;
  }



  //Report tabs toggle function
  const toggle = tab => {
    if (activeTab !== tab) setActiveTab(tab);
  }


  useEffect(() => {
    if (timeOrdered) {
      if (subgroupSize != '' && subgroupSizeValidated && sampleUnits > 0) {
        ////console.log(subgroupSize)
        validateInputParams();
      } else {
        setNewReportBtn(false);
      }
    } else {

      validateInputParams();
    }

  }, [timeOrdered, partialShipment, subgroupSize, MasterLotQty, subgroupSizeValidated, SubLotNum, SubLotQty, sampleUnits, AgileDocIDVer, PartNum, MasterLotNum, mstrLotCompletionDate]);

  useEffect(() => {
    if (PartNum && AgileDocIDVer && !fileGuid) {
      checkInspections();
    }

  }, [PONum, PartNum, AgileDocIDVer]);

  

  useEffect(() => {
    if (planDetails && details) {
      validateAllUnits();
    }

  }, [planDetails, details]);

  // useEffect(() => {
  //   if (!planDetailsList) {
  //     //console.log(planDetails)
  //     let tplanDetailsList = [];
  //     if (planDetails && planDetails.length > 0) {
  //       planDetails.map((el,i) => {
  //           tplanDetailsList.push(el.node);
  //       });
  //     }
  //     //console.log(tplanDetailsList);
  //       setPlanDetailsList(tplanDetailsList);
  //   }
  // }, [planDetails]);

  useEffect(() => {
    if (header) {

      let tHeader = header;
      if (planDetails && planDetails.length > 0) {
        tHeader['partDesc'] = planDetails[0].PartDesc;
        setHeader(tHeader);
      }
      if (header['factPlanID'] === BLANK_PLAN_ID) {
        validateAllUnits();
      }

    }
  }, [header]);

  //Event to get certificates and header details
  useEffect(() => {

    if (fileGuid) {
      if (!details) {
        setReportFileGUID(fileGuid);
        setShowLoading(true);
        if (!certificates) {
          getCertificates({ variables: { FileGUID: fileGuid } });
          GetInspectionLots({ variables: { FileGUID: fileGuid } });
        }
        getReportHeader({ variables: { FileGUID: fileGuid } });
      }
    }
  }, [details]);

  useEffect(() => {

    if (((details && planDetails)|| (header && !header['measureLotFlag'])) && certificates) {
      validateAllUnits();
    }

  }, [certificates]);

  //Event to get PO Details
  useEffect(() => {

    if (data) {
      ReactGA.initialize(config[window.location.hostname].ga_tracker, {
        debug: true,
        titleCase: false,
        gaOptions: {
          userId: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.name
        }
      });
      ReactGA.pageview(window.location.pathname + window.location.search);
      let t_openPO = [];
      let t_material = [];
      data.SupplierPO.edges.map((el) => {
        const checkPO = t_openPO.filter(po => po.PONum == el.node.PONum);
        const checkMaterial = t_material.filter(material => material.MaterialNum == el.node.MaterialNum);
        if (checkPO.length == 0) {
          t_openPO.push({ PONum: el.node.PONum });
        }

        if (checkMaterial.length == 0) {
          t_material.push({ MaterialNum: el.node.MaterialNum });
        }
      });
      t_openPO = t_openPO.sort((a, b) => parseFloat(a.PONum) - parseFloat(b.PONum));

      setOpenPO(t_openPO);
      t_material = t_material.sort((a, b) => parseFloat(a.MaterialNum) - parseFloat(b.MaterialNum));

      setPOMaterial(t_material);


      if (header) {

        let t_openPO1 = [];
        data.SupplierPO.edges.map((el) => {
         
          if (el.node.MaterialNum == header.PartNum && el.node.MaterialRev == header['AgileDocIDVer']) {

            const checkPO = t_openPO1.filter(po => po.PONum == el.node.PONum );

            if (checkPO.length == 0) {

              t_openPO1.push({ PONum: el.node.PONum });
            }

          }
        });



        setMaterialOpenPO(t_openPO1);

      }




    }
  }, [data, header]);

  useEffect(() => {
    if (certificates && header) {
    validateAllUnits();
    }
  },[certificates]);


  /*** functions to create new and submit data */

  const DownloadAndReset = (download) => {
    setShowPlanChange(false);
    exportData();
    handleSubmit('Draft', true)
  }

  const requirementsSelectionChange = (val) => {
    const i = selectedCertRequirements.indexOf(val)
    if (i > -1) {
      setSelectedCertRequirements(selectedCertRequirements.filter(item => item!== val));
    } else {
      setSelectedCertRequirements([...selectedCertRequirements, val]);
    }
  }

  console.log(requirementsList);
  const certSpecsTable = (!requirementsList || requirementsList.length<=0) ? null : 
    <ButtonGroup vertical>
      {
      requirementsList.map((el, i) => {
      return (
        // <tr key={i}>
        //   <td>{i+1}. {el}</td><td><input type='checkbox'/></td>
        // </tr>
          <Button outline color="success" active={selectedCertRequirements.includes(el)} onClick={() => requirementsSelectionChange(el)}>
            <p style={{color: 'black'}}>{selectedCertRequirements.includes(el) && <FontAwesomeIcon icon={faCheck} />}&nbsp;{el}</p>
          </Button>
      )

      })
      }
    </ButtonGroup>; 


  useEffect(() => {
    if (selectedCertRequirements.length !== requirementsList.length) {
      setCertRequirementsSatisfied(false)
    } else {
      for (let i = 0; i < selectedCertRequirements.length; i++) {
        if (!requirementsList.includes(selectedCertRequirements[i])) {
          setCertRequirementsSatisfied(false)
        }
      }
      setCertRequirementsSatisfied(true)
    }
  }, [selectedCertRequirements, requirementsList]);

  //function to handle submit operation
  //preSubmit flag is used to differentiate between whether to show a modal with computer vision requirements or not
  const handleSubmit = async (status, reset, preSubmit = false) => {
    const dirtyData = details.filter(data => data.dirty);

    if (preSubmit) {
      setShowCheckSubmitConfirmation(true);
    } else {
      setShowLoading(true);
      let tHeader = header;
      tHeader['PackingSlipNum'] = packingSlip;
      setHeader(tHeader);
      //if (planDetails && planDetails.length > 0) {
        const res = await UpdateSupplierFile({
          variables: {
            VendorNum: localStorage.getItem('loggedInVendor'),
            MasterLotNum: header['MasterLotNum'],
            MasterLotQty: header['MasterLotQty'],
            SubLotNum: SubLotNum,
            SubLotQty: SubLotQty,
            PartNum: header['PartNum'],
            AgileDocIDVer: header['AgileDocIDVer'],
            Program: subgroupSize,
            SupplierLogID: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username,
            PONum: header['PONum'],
            ResetPlan: reset,
            FileGUID: reportFileGUID,
            UpdateTS: '',
            LoadTS: '',
            Status: status,
            sampleUnits: (header.measureLotFlag) ? sampleUnits : 0,
            inspData: JSON.stringify(dirtyData),
            factPlanID: header['factPlanID'],
            timeOrder: (timeOrdered) ? 1 : 0,
            PackingSlipNum: packingSlip,
            PartialShipmentFlag: (partialShipment) ? 1 : 0,
            mstrLotCompletionDate: header['mstrLotCompletionDate']
          }
        });

        if (res.data.UpdateSupplierFile.iDetail.FileGUID.indexOf('Error Processing') >= 0 || res.data.UpdateSupplierFile.iDetail.FileGUID.indexOf('Failed') >= 0) {
          // alert(res.data.UpdateSupplierFile.iDetail.FileGUID);
          if (res.data.UpdateSupplierFile.iDetail.FileGUID == 'Failed - Alert Plan ID change') {
            setShowPlanChange(true);
          } else {
            alert(res.data.UpdateSupplierFile.iDetail.FileGUID)
          }
          setShowLoading(false);
        } else {
          if (status == 'Processed') {
            getFileValidationDetails({ variables: { FileGUID: reportFileGUID } });
            let tHeader = header;
            tHeader['Status'] = 'Processed';
            setHeader(tHeader);
            let tDetails = details;
              tDetails.map((el, i) => {
                el['dirty'] = false;
              });
              updateInspectionCache(reportFileGUID, tDetails,'update', 'new');
              // setDetails(tDetails);
              setShowSubmitConfirmation(true);
          } else {
            let tDetails = details;

            tDetails.map((el, i) => {

              el['dirty'] = false;
            });
            updateInspectionCache(reportFileGUID, tDetails,'update', 'new');
            setShowSaveConfirmation(true);
          }
          setShowLoading(false);

        }
        setShowCheckSubmitConfirmation(false)
      // } else {
      //   setPlanError(true);
      // }
    }

  }

  console.log(planDetails)
  //Create a new report function
  const insertData = async (headerObject, detailObject, planDetails) => {
    //if (planDetails && planDetails.length > 0) {
      ////console.log(planDetails);
      const res = await SupplierFileHeader({
        variables: {
          VendorNum: localStorage.getItem('loggedInVendor'),
          MasterLotNum: headerObject['MasterLotNum'],
          MasterLotQty: headerObject['MasterLotQty'],
          SubLotNum: (headerObject['SubLotNum'] == null ? 0 : headerObject['SubLotNum']),
          SubLotQty: (headerObject['SubLotQty'] == null ? 0 : headerObject['SubLotQty']),
          PartNum: headerObject['PartNum'],
          AgileDocIDVer: headerObject['AgileDocIDVer'],
          Program: subgroupSize,
          SupplierLogID: JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims.preferred_username,
          PONum: headerObject['PONum'],
          FileGUID: '',
          UpdateTS: '',
          LoadTS: '',
          Status: 'Draft',
          sampleUnits: (sampleUnits == null ? 0 : sampleUnits),
          DetailString: JSON.stringify(detailObject),
          factPlanID: (headerObject['factPlanID']) ? headerObject['factPlanID'] : (planDetails && planDetails.length > 0) ? planDetails[0].PlanID : null,
          timeOrder: (timeOrdered) ? 1 : 0,
          PackingSlipNum: packingSlip,
          PartialShipmentFlag: (partialShipment) ? 1 : 0,
          mstrLotCompletionDate: headerObject['mstrLotCompletionDate'],
          MeasurementsProvided: (measurementsUpload)? 1 : 0
        }
      });

      if (res.data.SupplierFileHeader.iHeader.FileGUID.trim() == 'Error processing') {
        alert(res.data.SupplierFileHeader.iHeader.Status);
        setHeader(null)
        fileGuid = null;
        setShowLoading(false);
      } else if (res.data.SupplierFileHeader.iHeader.FileGUID == 'Full shipment is already done for this MasterLotNum') {
        alert('Full shipment is already done for this MasterLotNum');
        fileGuid = null;
        setShowLoading(false);
      } else {
        headerObject['measureLotFlag'] = res.data.SupplierFileHeader.iHeader.MeasureLotFlag;
        setHeader(headerObject);
        setShowLoading(false);
        setReportFileGUID(res.data.SupplierFileHeader.iHeader.FileGUID);
        setMeasureLotFlag(res.data.SupplierFileHeader.iHeader.MeasureLotFlag);
        setReportMode('Draft');
        setSubgroupData(detailObject, headerObject);

        getReportDetail({ variables: { FileGUID: res.data.SupplierFileHeader.iHeader.FileGUID } });
      }
    // } else {
    //   setPlanError(true);
    // }
  };

  //Create new port
  const createNewReport = () => {
    // if (PONum && AgileDocIDVer && PartNum && MasterLotNum && MasterLotNum && SubLotNum && SubLotQty && sampleUnits && sampleUnits && mstrLotCompletionDate) {
    if (newreportBtn) {
      //if (planDetails && planDetails.length > 0) {
        setShowLoading(true);
        let headerObject = {};
        headerObject['PartNum'] = PartNum;
        headerObject['AgileDocIDVer'] = AgileDocIDVer;
        headerObject['PONum'] = PONum;
        headerObject['MasterLotNum'] = MasterLotNum;
        headerObject['MasterLotQty'] = MasterLotQty;
        headerObject['SubLotNum'] = SubLotNum;
        headerObject['SubLotQty'] = SubLotQty;
        if (planDetails && planDetails.length > 0) {
          headerObject['partDesc'] = planDetails[0].PartDesc;
        }
        headerObject['sampleUnits'] = sampleUnits;
        headerObject['Program'] = subgroupSize;
        headerObject['mstrLotCompletionDate'] = mstrLotCompletionDate;
        headerObject['PackingSlipNum'] = packingSlip;
        setHeader(headerObject);
        if (!fileGuid) {
          const tPlanDetails = planDetails && planDetails.length > 0 ? planDetails : [];
          let tdetails = [];
          insertData(headerObject, tdetails, tPlanDetails);
        }


      // } else {
      //   setPlanError(true);
      // }
    }
  }
  /** end of create new submit functions **/


  /*** Helper methods to build/validate input template */

  //method to build certificate list
  let certFilesData = (!certsArray) ? null : certsArray.map((el, i) => {
    return (
      <tr><td>{el.name}</td></tr>
    )
  });

  //method to build loaded files list

  const loadedFiles = (!certificates) ? null : certificates.map((el, i) => {
    return (
      <tr><td>{el.node.FileName}</td>
        <td><a href='#' onClick={(e) => deleteFile(el)}>Delete</a></td></tr>
    )
  });

  //method to build labels
  const tlabels = (!planDetails) ? null : planDetails.map((el, i) => {
    return (
      // <div class="rcol-md-3" scope="col" style={{ whiteSpace: 'nowrap' ,textAlign:'center' }} key={i}>{el.node.Label}<p style={{marginBottom:'0px'}}>{el.node.LabelNum}</p></div>
      <div class="rcol-md-3" scope="col" style={{ whiteSpace: 'nowrap', textAlign: 'center' }} key={i}>{el.Label}<p style={{ marginBottom: '0px' }}>Balloon{el.BaloonNum}</p></div>

    )
  });

  //method to build methods
  const tmethods = (!planDetails) ? null : planDetails.map((el, i) => {
    return (
      <div class="rcol-md-3" scope="col" style={{ whiteSpace: 'nowrap', textAlign: 'center' }} key={i}>{el.Method}</div>
    )
  });

  //method to build sampling
  const tsampling = (!planDetails) ? null : planDetails.map((el, i) => {
    return (
      <div class="rcol-md-3" scope="col" style={{ whiteSpace: 'nowrap', textAlign: 'center' }} key={i}>{el.Sampling}</div>
    )
  });

  //method to build charateristics
  const tcharacteristic = (!planDetails) ? null : planDetails.map((el, i) => {
    let Characteristic = el.Characteristic;

    if (el.Characteristic.length > 20) {
      Characteristic = el.Characteristic.substring(0, 20)
    }
    return (
      <div class="rcol-md-3" scope="col" style={{ whiteSpace: 'nowrap', textAlign: 'center' }} id={'charcteristic' + i} key={i}><a href='#'>{Characteristic}</a>
        <UncontrolledTooltip placement="right" target={'charcteristic' + i}>
          <div style={{ margin: '10px' }}>
            <div class="row"><b>Balloon:</b> {el.BaloonNum}</div>
            <div class="row"><b>Sheet & Zone:</b> {el.NumPlaces} - {el.SheetNum}</div>
            <div class="row"><b>Characteristic:</b> {el.Characteristic}</div>
          </div>

        </UncontrolledTooltip>

      </div>
    )
  });

  const updateInspectionCache = (inspectionID,details,loadType, actionType) => {

    //Check if inspection cache object exists or not..
    if (!localStorage.getItem('VPIInspectionCache') &&  loadType == 'initial' && actionType == 'new') {
        let inspectionCache = [];
        let inspectionObject = {'FileGuid': inspectionID, 'details': details};
        inspectionCache.push(inspectionObject);
        localStorage.setItem('VPIInspectionCache',JSON.stringify(inspectionCache));
        setDetails([...details]);
    } else {
      let InspectionList = JSON.parse(localStorage.getItem('VPIInspectionCache'));
      const inspObject = InspectionList.filter(inspection => inspection['FileGuid'] ==  inspectionID);
      if (inspObject.length > 0 && inspObject[0].FileGuid == inspectionID ) {
        if (actionType == 'new') {
              if (loadType == 'update') {

                inspObject[0].details = details;
                setDetails([...inspObject[0].details]);
                localStorage.setItem('VPIInspectionCache',JSON.stringify(InspectionList));
              }  else {
                setDetails([...inspObject[0].details]);
                localStorage.setItem('VPIInspectionCache',JSON.stringify(InspectionList));
              }
        } else if (actionType == 'save') {
            let InspectionCache = InspectionList.filter(inspection => inspection['FileGuid'] !=  inspectionID);
            //console.log(InspectionCache)
            localStorage.setItem('VPIInspectionCache',JSON.stringify(InspectionCache));
        }
       
      } else {
        if (loadType == 'initial'  && actionType == 'new' ) {
          let InspectionList = JSON.parse(localStorage.getItem('VPIInspectionCache'));
          let inspectionObject = {'FileGuid': inspectionID, 'details': details};
          InspectionList.push(inspectionObject);
          localStorage.setItem('VPIInspectionCache',JSON.stringify(InspectionList));
          setDetails([...details]);
        }
      }
    }
  }

  const clearFeatureValues = (el) => {
            //console.log(el)
            let tDetails = details;
              const featureValues = tDetails.filter(row => row['ColSlNum'] ==  el['node']['ColSlNum']);
              featureValues.map((el1,j) => {
                  el1.Val = '';
              })
          //console.log(tDetails);    
      updateInspectionCache(reportFileGUID, tDetails,'update', 'new');
      // setDetails([...tDetails]);
      validateAllUnits();
  }


  //method to buold LSLUSL
  const tLSLUSL = (!planDetails) ? null : planDetails.map((el, i) => {
    let measureString = '';

    if (el.SpecDataType == 'Attribute') { //Attributes are always PASS/FAIL
      
      measureString = 'PASS/FAIL';
    } else if (el.SpecDataType.trim() == 'Variable' && el.SpecType.trim() != 'GD&T') { //IF SPECTYPE is GD&T 
      if (Number(el.LSL) > 0 && Number(el.USL) == 0) {
        measureString = Number(el.LSL).toFixed(el.Precision) + '- n/a ';
      } else if (Number(el.LSL) == 0 && Number(el.USL) > 0) {
        measureString = 'n/a - ' + Number(el.USL).toFixed(el.Precision);
      }
      else {
        measureString = Number(el.LSL).toFixed(el.Precision) + '-' + Number(el.USL).toFixed(el.Precision);
      }

    } else if (el.SpecDataType.trim() == 'Variable' && el.SpecType.trim() == 'GD&T') {
      if (Number(el.SpecValTOLMinus).toFixed(el.Precision) > 0 && Number(el.SpecValTOLPlus).toFixed(el.Precision) == 0) {
        measureString = Number(el.SpecValTOLMinus).toFixed(el.Precision) + '- n/a ';
      } else if (Number(el.SpecValTOLMinus).toFixed(el.Precision) == 0 && Number(el.SpecValTOLPlus).toFixed(el.Precision) > 0) {
        measureString = ' n/a - ' + Number(el.SpecValTOLPlus).toFixed(el.Precision);
      } else {
        measureString = Number(el.SpecValTOLMinus).toFixed(el.Precision) + '-' + Number(el.SpecValTOLPlus).toFixed(el.Precision);
      }
    }
   

    return (
      <div class="rcol-md-3" scope="col" style={{ marginTop: '2px', whiteSpace: 'nowrap', textAlign: 'center' }} key={i}>
        {measureString}
        {(measureString == 'PASS/FAIL')  ? null: <i onClick={() => clearFeatureValues(el)} style={{display:reportMode === 'Draft' ? "inline" : "none",marginLeft: '10px', cursor: 'pointer'}} class="fas fa-trash-alt"></i>}
        {(measureString == 'PASS/FAIL') ?
          <>
            <div class="rrow"><div style={{ display: 'inline' }} class="ivrcol-md-3 custom-control custom-radio">
              <Button id={"allpassfail" + i + "pass"} name={"allpassfail" + i} onClick={() => { setAllPassFail(i, 'PASS') }} disabled={(reportMode != 'Draft') ? true : false} color="primary">Set All Pass</Button>{' '}
            </div></div>
            {/* <div class="rrow"><div style={{ display: 'inline', marginLeft: '5px' }} class="ivrcol-md-3 custom-control custom-radio">
              <input disabled={(reportMode != 'Draft') ? true : false} type="radio" class="custom-control-input" id={"allpassfail" + i + "pass"} name={"allpassfail" + i} onClick={() => { setAllPassFail(i, 'PASS') }} />
              <label class="custom-control-label" for={"allpassfail" + i + "pass"}>All Pass </label>
            </div>
              <div style={{ display: 'inline', marginLeft: '5px' }} class="ivrcol-md-3 custom-control custom-radio">
                <input disabled={(reportMode != 'Draft') ? true : false} type="radio" class="custom-control-input" id={"allpassfail" + i + "fail"} name={"allpassfail" + i} onClick={() => { setAllPassFail(i, 'FAIL') }} />
                <label class="custom-control-label" for={"allpassfail" + i + "fail"}>All Fail </label>
              </div></div> */}


          </> : <div></div>}

      </div>
    )
  });


  //build units template
  const units = [];
  for (var i = 0; i < sampleUnits; i++) {
    units.push(i);
  }


  //Method to validate all inputs on every change
  const validateAllUnits = () => {

    let issubmitEnabled = false;
    let breakOut = false;

    if (!header['measureLotFlag'] || !details ) {
      issubmitEnabled = true;
    } else {

      //Loop through all details
      details.map((el) => {
        if (!breakOut) { //if not breakout
          //get plan for the current value
          let plan = planDetails.filter(p => p.Label == el.Label && p.ColSlNum == el.ColSlNum);
          if (plan.length > 0) {
            if (timeOrdered) { //if timeoredered check subgroup and sampling time values
              if (el.samplingTime == '' || el.samplingTime == null || el.subGroup == '' || el.samplingTime == '1900-01-01T00:00:00') {
                issubmitEnabled = false;
                breakOut = true;
                setSampleTimeValidated(false);
              } else {
                setSampleTimeValidated(true);
              }
            }

            // if any value is blank break out
            if (!el.Val && !breakOut) {
              issubmitEnabled = false;

              breakOut = true;
              setUnitsValidated(false);
            }
            //if spec data type is attribute make sure values are pass before breaking out
            if (plan[0].SpecDataType == 'Attribute' && !breakOut) {

              if (el.Val && el.Val.toUpperCase() == 'PASS') {
                issubmitEnabled = true;

                setUnitsValidated(true);
              } else {
                issubmitEnabled = false;
                breakOut = true;
                setUnitsValidated(false);

              }

            }
            else { // if spec data type is Variable

              //if spec type GD&T
              if (plan[0].SpecType == 'GD&T' && plan[0].BonusTOL == 1 && !breakOut) {

                // use specvalue tol plus and minus as LSL/USL
                let lsl = Number((plan[0].SpecValTOLMinus == null) ? 0 : plan[0].SpecValTOLMinus);
                let usl = Number(plan[0].SpecValTOLPlus);
               
                //check if the value is between plan LSL and USL
                if (Number(el.Val).toFixed(plan[0].Precision) < lsl.toFixed(plan[0].Precision) || Number(el.Val).toFixed(plan[0].Precision) > (Number(usl.toFixed(plan[0].Precision)) + Number(el.bonus)).toFixed(plan[0].Precision)) {
                 
                  issubmitEnabled = false;
                  breakOut = true;
                  setUnitsValidated(false);
                } else {
                  if (!breakOut) {
                    setUnitsValidated(true);
                    issubmitEnabled = true;
                  }
                }
              } else { //not gd&t
                if (plan[0].SpecDataType == 'Variable' && !breakOut) {

                  let lsl = Number(plan[0].LSL).toFixed(plan[0].Precision);
                  let usl = Number(plan[0].USL).toFixed(plan[0].Precision)
                  if (plan[0].SpecType == 'GD&T') {
                    lsl = Number(plan[0].SpecValTOLMinus).toFixed(plan[0].Precision);
                    usl = Number(plan[0].SpecValTOLPlus).toFixed(plan[0].Precision)
                  }

                  //check value is between LSL and USL
                  if (lsl != null && usl != null) {
                    if (Number(lsl) > 0 && Number(usl) == 0) {
                      if (Number(el.Val) < lsl && !breakOut) {

                        issubmitEnabled = false;
                        breakOut = true;
                        setUnitsValidated(false);
                      } else {

                        if (!breakOut) {
                          setUnitsValidated(true);
                          issubmitEnabled = true;
                        }
                      }
                    } else {
                      if (Number(el.Val) < lsl || Number(el.Val) > usl && !breakOut) {

                        issubmitEnabled = false;
                        breakOut = true;
                        setUnitsValidated(false);
                      } else {

                        if (!breakOut) {
                          setUnitsValidated(true);
                          issubmitEnabled = true;
                        }
                      }
                    }
                  } else {
                    issubmitEnabled = false;
                    breakOut = true;
                    setUnitsValidated(false);

                  }
                }
              }
            }

          } else {
            setPlanError(true);
            breakOut = true;
          }
        }

      });

      if (details.length == 0) {
        setUnitsValidated(true);
        issubmitEnabled = true;
      }
    }

    if (!certificates || certificates.length == 0) {
      issubmitEnabled = false;
    }

   

    //enable disable submit/accept button
    if (issubmitEnabled) {
      setSubmitEnabled(issubmitEnabled);
    } else {
      setSubmitEnabled(false);
    }


  }


  //method to handle every cell value change, to validate the data and update details state
  const handleCellValueChange = async (unit, column, val, lsl, usl, bonus, feature_precision) => {
    if (val == 'PASS' || val == 'FAIL') {
      let tDetails = details;
      tDetails.map((el) => {

        if (el.UnitNo == unit && el.ColSlNum == column) {
       
          el['dirty'] = true;
          if (bonus) {
           
            el.bonus = val;
          } else {
            el.Val = val;
          }


        }
      });
      // setDetails([...details]);
      updateInspectionCache(reportFileGUID, tDetails, 'update','new');
      validateAllUnits();

    } else {
      // if (Number(lsl) > 0 && Number(usl) > 0 && isNaN(val) && val != '.') {
      //   return false;
      // }
      ////console.log(Number(val));
      if (!isNaN(Number(val)) || val == '.') {
        let tDetails = details;
        tDetails.map((el) => {

          if (el.UnitNo == unit && el.ColSlNum == column) {
            el['dirty'] = true;
            if (bonus == true) {
              let t_val = val;
              let t_val1 = "";
              let t_val2 = "";
              // feature_precision = 3;
              if (t_val.indexOf('.') >= 0) {
                t_val1 = t_val.substring(0, t_val.indexOf('.'))
                t_val2 = t_val.substring(t_val.indexOf('.') + 1);
              
                // val = t_val1 + '.' + t_val2.substring(0, Number(feature_precision) + 1);
                val = t_val1 + '.' + t_val2;
              }
              el.bonus = val.replace(/^0+/, '');
              //console.log(el.bonus)
              el['dirty'] = true;



            } else {

              let t_val = val;
              let t_val1 = "";
              let t_val2 = ""


            if (bonus == 'gdt') {

              if (Number(lsl) == 0 && Number(usl) == 0) {
                feature_precision = 3;
              }
           }

              if (t_val.indexOf('.') >= 0) {
                t_val1 = t_val.substring(0, t_val.indexOf('.'))
                t_val2 = t_val.substring(t_val.indexOf('.') + 1);
                val = t_val1 + '.' + t_val2.substring(0, Number(feature_precision) + 1);
              }
              el.Val = val.replace(/^0+/, '');
            }
          }
        });

        // setDetails([...details]);
        updateInspectionCache(reportFileGUID, tDetails, 'update','new');
        validateAllUnits();
        // }
      }
    }

  };

  //help function to get row data for a given unit and feature
  function getRowData(i, j) {
   
    const result = details.filter(unit => unit.UnitNo == i && unit.ColSlNum == j);
    return result
  }

  //method to validate master lot completion date
  const changeMstrLotCompletionDate = (e) => {
    try {
      if (e.diff(new Date()) <= 0) {
        let tdate = e.tz("America/Los_Angeles").format('MM/DD/YYYY');

        setMstrLotCompletionDate(tdate);
        validateInputParams();
      } else {
        setMstrLotCompletionDate(null);

        return false;
      }
    } catch (er) {
      setMstrLotCompletionDate(null);
      validateInputParams();

      return false;
    }
  }


  //method to validate sample time data
  const changeSampleTime = (e, i) => {
    console.log(e)
    try {
      console.log(e.diff(new Date()))
      if (e.diff(new Date()) <= 0) {
        let tDetails = details;
        tDetails.map((el) => {
          if (el.UnitNo == i + 1) {
            let tdate = e.format('MM/DD/YYYY');
            el.samplingTime = new Date(tdate).toLocaleDateString();
            el['dirty'] = true;
          }
        });
        updateInspectionCache(reportFileGUID, tDetails, 'update','new');
        // setDetails([...tDetails]);
        validateAllUnits();
      } else {
        let tDetails = details;
        tDetails.map((el) => {
          if (el.UnitNo == i + 1) {
            let tdate = e.format('MM/DD/YYYY');
            el.samplingTime = null;
            el['dirty'] = true;
          }
        });
        console.log(tDetails);
        updateInspectionCache(reportFileGUID, tDetails, 'update','new');
        validateAllUnits();
        return false;
      }
    } catch (er) {
      let tDetails = details;
      tDetails.map((el) => {
        if (el.UnitNo == i + 1) {

          el.samplingTime = null;
          el['dirty'] = true;
        }
      });
      console.log(tDetails);
      updateInspectionCache(reportFileGUID, tDetails, 'update','new');
      validateAllUnits();
      return false;
    }
  }

  //helper method to set all radio buttons to pass/fail
  const setAllPassFail = (column, mode) => {
    let tDetails = details;
    tDetails.map((el) => {
      if (el.ColSlNum == column + 1) {
        el.Val = mode;
        el['dirty'] = true;
      }
    });
    // setDetails([...tDetails]);
    updateInspectionCache(reportFileGUID, tDetails,'update', 'new');
    validateAllUnits();

  }

  //method to validate subgroup value
  const changeSubGroup = (e, i) => {
    let tDetails = details;
    tDetails.map((el) => {
      if (el.UnitNo == i + 1) {
        el.subGroup = parseInt(e.target.value);
        el['dirty'] = true;
      }
    });
    updateInspectionCache(reportFileGUID, tDetails,'update', 'new');
    // setDetails([...tDetails]);
    validateAllUnits();
  }

  //method to validate cavity id
  const changeCavityID = (e, i) => {
    let tDetails = details;
    tDetails.map((el) => {
      if (el.UnitNo == i + 1) {
        el.cavityID = e.target.value;
        el['dirty'] = true;
      }
    });
    updateInspectionCache(reportFileGUID, tDetails,'update', 'new');
    // setDetails([...tDetails]);
  }


  //helper method for GD&T field value color coding
  const checkGDTColor = (i, j, lsl, usl, val, precision, bonusVal) => {

    if (Number(lsl) == 0 && Number(usl) == 0) {
      precision = 3;
   }

   if (Number(val) < lsl.toFixed(precision) || Number(val) > (Number(usl.toFixed(precision)) + Number(bonusVal))) {
     return 'red';
   } else {
     return 'black';
   }
  }

  //helper method for field value color coding
  const checkValColor = (i, j, lsl, usl, val, precision) => {

    
    if (Number(lsl) > 0 && Number(usl) == 0) {
      if (Number(val) < lsl.toFixed(precision)) {
        return 'red';
      } else {
        return 'black';
      }
    } else {
      if (Number(val) < lsl.toFixed(precision) || Number(val) > (Number(usl.toFixed(precision)))) {
        return 'red';
      } else {
        return 'black';
      }
    }
  }

  //Method to reset all data entered for the report
  const handleReset = () => {
    setShowReset(true);
  }
  const compleationDateValidation = (currentDate) => {
    return (
      currentDate.isBefore(moment()) &&
      currentDate.isAfter(moment("12/31/1999").format("MM/DD/YYYY"))
    );
  }


  //method to build unit row display template
  const t_valueRows = (!details || !planDetails) ? null :
    units.map((el, i) => {
      const result = details.filter(unit => unit.UnitNo == i + 1);

      return result.length > 0 ? (
        <div class="rrow" key={i}>
          <div
            class="vrcol-md-3"
            style={{
              backgroundColor: "#bfbdc5",
              zIndex: 10,
              verticalAlign: "middle",
              fontWeight: "bold",
              position: "sticky",
              left: 0,
            }}
          >
            <strong>Unit {i + 1}</strong>
          </div>
          {timeOrdered ? (
            <div
              class="vrcol-md-3"
              style={{ verticalAlign: "middle", fontWeight: "bold" }}
            >
              {reportMode != "Draft" ? (
                <span>
                  {moment(result[0].samplingTime)
                    .tz("America/Los_Angeles")
                    .format("MM/DD/YYYY, h:mm:ss a")}
                </span>
              ) : (
                <Datetime
                  utc={false}
                  name={"samplingTime|" + i}
                  isValidDate={compleationDateValidation}
                  input={true}
                  onChange={(e) => changeSampleTime(e, i)}
                  defaultValue=""
                  value={
                    result[0].samplingTime == "" ||
                    result[0].samplingTime == null
                      ? ""
                      : moment(new Date(result[0].samplingTime)).tz(
                          "America/Los_Angeles"
                        )
                  }
                />
              )}
            </div>
          ) : null}
          {timeOrdered ? (
            <div
              class="vrcol-md-3"
              style={{ verticalAlign: "middle", fontWeight: "bold" }}
            >
              <Input
                autocomplete="off"
                id={"subGroup|" + i}
                disabled={true}
                value={result[0].subGroup}
                onChange={(e) => changeSubGroup(e, i)}
              />
            </div>
          ) : null}
          <div
            class="vrcol-md-3"
            style={{ verticalAlign: "middle", fontWeight: "bold" }}
          >
            <Input
              autocomplete="off"
              id={"cavityID|" + i}
              disabled={reportMode != "Draft" ? true : false}
              value={result[0].cavityID}
              onChange={(e) => changeCavityID(e, i)}
            />
          </div>
          <div class="brcol-md-31"></div>
          {planDetails.map((el1, j) => {
            let enabled = false;
            let display = "inline";
            let passClass = "";
            let disabled = false;
            let failClass = "";

            let lsl = Number(el1.LSL);
            let usl = Number(el1.USL);
            if (el1.SpecType == "GD&T") {
              lsl = Number(
                el1.SpecValTOLMinus == null ? 0 : el1.SpecValTOLMinus
              );
              usl = Number(el1.SpecValTOLPlus);
            }

            let val = 0;
            let bonusVal = 0;

            let detailRow = getRowData(i + 1, el1.ColSlNum);
            if (detailRow[0]) {
              val = detailRow[0].Val;
              if (detailRow[0].bonus != null) {
                bonusVal = detailRow[0].bonus;
              }

              if (val == "PASS") {
                passClass = "checked";
              } else {
                passClass = "";
              }

              if (val == "FAIL") {
                failClass = "checked";
              } else {
                failClass = "";
              }
            }

            if (i > 0 && el1.Sampling == "1 per lot") {
              enabled = true;
              display = "none";
            }
            if (
              el1.SpecDataType == "Attribute" &&
              el1.Sampling == "Squeglia C=0"
            ) {
              enabled = true;
            }

            // console
            return (
              <div
                class="vrcol-md-3"
                key={j}
                style={{ margin: "none", padding: "none" }}
              >
                {el1.SpecDataType == "Attribute" ? (
                  <div
                    role="group"
                    className="brcol-md-31 btn-group-sm btn-group"
                    style={{ display: display }}
                  >
                  {(detailRow[0])?<>  <div
                      style={{ display: "inline", marginLeft: "5px" }}
                      class="ivrcol-md-3 custom-control custom-radio"
                    >
                      <input
                        autocomplete="off"
                        disabled={reportMode != "Draft" ? true : false}
                        checked={passClass}
                        type="radio"
                        class="custom-control-input"
                        id={"passfail" + i + "-" + j + "pass"}
                        name={"passfail" + i + "-" + j}
                        onClick={() => {
                          handleCellValueChange(
                            i + 1,
                            j + 1,
                            "PASS",
                            lsl,
                            usl,
                            false,
                            0,
                            0
                          );
                        }}
                      />
                      <label
                        disabled={reportMode != "Draft" ? true : false}
                        class="custom-control-label"
                        for={"passfail" + i + "-" + j + "pass"}
                      >
                        Pass{" "}
                      </label>
                    </div>
                    <div
                      style={{ display: "inline", marginLeft: "5px" }}
                      class="ivrcol-md-3 custom-control custom-radio"
                    >
                      <input
                        autocomplete="off"
                        disabled={reportMode != "Draft" ? true : false}
                        checked={failClass}
                        type="radio"
                        class="custom-control-input"
                        id={"passfail" + i + "-" + j + "fail"}
                        name={"passfail" + i + "-" + j}
                        onClick={() => {
                          handleCellValueChange(
                            i + 1,
                            j + 1,
                            "FAIL",
                            lsl,
                            usl,
                            false,
                            0,
                            0
                          );
                        }}
                      />
                      <label
                        disabled={reportMode != "Draft" ? true : false}
                        class="custom-control-label"
                        for={"passfail" + i + "-" + j + "fail"}
                      >
                        Fail{" "}
                      </label>
                    </div></>: <span style={{ width: '100%', textAlign: 'center' }}>N/A</span>}
                  </div>
                ) : (
                  <div class="ivrcol-md-3">
                    {detailRow[0] &&
                    el1.SpecType == "GD&T" &&
                    el1.BonusTOL == 1 ? (
                      <InputGroup style={{ width: "300px" }}>
                        <Input
                          autocomplete="off"
                          disabled={reportMode != "Draft" ? true : false}
                          id={"column" + j + "|row-" + i}
                          value={val}
                          style={{
                            display: display,
                            border:
                              checkGDTColor(
                                i + 1,
                                j + 1,
                                lsl,
                                usl,
                                Number(val),
                                el1.Precision,
                                bonusVal
                              ) == "red"
                                ? "1px normal red"
                                : "",
                            color: checkGDTColor(
                              i + 1,
                              j + 1,
                              lsl,
                              usl,
                              Number(val),
                              el1.Precision,
                              bonusVal
                            ),
                            minWidth: "85px",
                          }}
                          onChange={(e) =>
                            handleCellValueChange(
                              i + 1,
                              j + 1,
                              e.target.value,
                              lsl.toFixed(el1.Precision),
                              usl.toFixed(el1.Precision),
                              "gdt",
                              el1.Precision
                            )
                          }
                        />
                        <Input
                          disabled={reportMode != "Draft" ? true : false}
                          id={"bonus" + j + "|row-" + i}
                          value={bonusVal.toString().replace(/^0+/, "")}
                          placeholder="Bonus"
                          onChange={(e) =>
                            handleCellValueChange(
                              i + 1,
                              j + 1,
                              e.target.value,
                              lsl,
                              usl,
                              true,
                              el1.Precision
                            )
                          }
                        />{" "}
                      </InputGroup>
                    ) : (
                     <> {(detailRow[0])?   <InputGroup>
                        <Input
                          autocomplete="off"
                          disabled={reportMode != "Draft" ? true : false}
                          id={"column" + j + "|row-" + i}
                          value={val}
                          style={{
                            display: !enabled ? "block" : "none",
                            color: checkValColor(
                              i + 1,
                              j + 1,
                              lsl,
                              usl,
                              Number(val),
                              el1.Precision
                            ),
                            minWidth: "85px",
                          }}
                          onChange={(e) =>
                            handleCellValueChange(
                              i + 1,
                              j + 1,
                              e.target.value,
                              lsl.toFixed(el1.Precision),
                              usl.toFixed(el1.Precision),
                              false,
                              el1.Precision
                            )
                          }
                        />
                      </InputGroup>: <span style={{ width: '100%', textAlign: 'center' }}>N/A</span>}</>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ) : null;
    });

  //helper method to paste data into a feature column
  const handlePaste = (e) => {

    let column = e.target.id;
    if (column == 0) {
      column = 'samplingTime'
    }
    let dataPasted = e.clipboardData.getData('text/plain').split("\n");
    setTimeout(() => { pasteData(column, dataPasted) }, 200);
  }

  const pasteData = (column, dataPasted) => {
    if (column.indexOf('subGroup') >= 0 || column.indexOf('samplingTime') >= 0 || column.indexOf('cavityID') >= 0 || column.indexOf('bonus') >= 0) {
      let columnID = column.split('|')[0];

      let tDetails = details;
      for (var i = 0; i < dataPasted.length; i++) {
        tDetails.map((el) => {
          if (el.UnitNo == i + 1) {
            if (column.indexOf('samplingTime') >= 0) {
              if (moment(dataPasted[i].replace(/\s+/g, ' ').trim()).diff(new Date()) <= 0) {
                el[columnID] = moment(dataPasted[i].replace(/\s+/g, ' ').trim());
                el['dirty'] = true;
              }
            } else if (column.indexOf('subGroup') >= 0) {
              el[columnID] = parseInt(dataPasted[i].replace(/\s+/g, ' ').trim());
              el['dirty'] = true;
            } else if (column.indexOf('bonus') >= 0) {
              let columnIdx = columnID.replace('bonus', '');
              if (el.ColSlNum == Number(columnIdx) + 1 && el.UnitNo == i + 1) {

                el.bonus = parseFloat(truncateValues(columnIdx, dataPasted[i].replace(/\s+/g, ' ').trim()));
                el['dirty'] = true;

              }
            } else {
              el[columnID] = dataPasted[i].replace(/\s+/g, ' ').trim();
              el['dirty'] = true;
            }


          }
        });
      }

    } else {
      let columnID = column.split('|')[0];
      let columnIdx = columnID.replace('column', '');

      let tDetails = details;
      let broken = false;
      for (var i = 0; i < dataPasted.length; i++) {
        tDetails.map((el) => {
          if (!broken) {
          if (el.ColSlNum == Number(columnIdx) + 1 && el.UnitNo == i + 1) {
            if (!isNaN(Number(dataPasted[i].replace(/\s+/g, ' ').trim()))) {
              el.Val = truncateValues(columnIdx, dataPasted[i].replace(/\s+/g, ' ').trim());
              // el.Val = dataPasted[i].replace(/\s+/g, ' ').trim();
              el['dirty'] = true;
            } else {
              broken = true;
            }

          }
        }
        });
      }
      if (broken) {
        alert('Please do not paste no numeric values');
      }
    }
    updateInspectionCache(reportFileGUID, details,'update', 'new');
    // setDetails([...details]);
    validateAllUnits();

  };

  //helper method to truncate values
  const truncateValues = (columnIdx, value) => {
    let returnVal = "";
    planDetails.map((elplan) => {
      if (elplan.ColSlNum == Number(columnIdx) + 1) {
        let t_val = value;
        let t_val1 = "";
        let t_val2 = "";
        let val = "";
        if (t_val.indexOf('.') >= 0) {
          t_val1 = t_val.substring(0, t_val.indexOf('.'))
          t_val2 = t_val.substring(t_val.indexOf('.') + 1);
          val = t_val1 + '.' + t_val2.substring(0, Number(elplan.Precision) + 1);
        } else {
          val = value;
        }

        returnVal = val.replace(/^0+/, '');

      }
    });

    return returnVal;


  }



  /**** end of helper methods for create/validate input template */

  const navigateHome = () => {
    let dirtyData = [];
    if (details) {
      dirtyData = details.filter(data => data.dirty);
      ////console.log(dirtyData);
    }
    // if (dirtyData.length > 0 && reportMode != 'Processed') {
    //   alert('Please save data before leaving')
    // } else {
      history.push({
        pathname: '/supplier/LandingPage'
      });
    // }

  }

  /****************   create new report form  validation functions */

  //validate create new report input form
  const validateInputParams = () => {
    let broken = false;
    if (document.getElementById('NewReportBtn')) {
      if (showPlanDoesNotExist) {
        document.getElementById('NewReportBtn').style.display = 'none';
      }
      else {
        document.getElementById('NewReportBtn').style.display = 'block';
      }
    }

    if (MasterLotNum && special_chars.test(MasterLotNum)){
        setInvalidMasterLot(true);
    }else{
        setInvalidMasterLot(false);
    }
      if (
        AgileDocIDVer &&
        PartNum &&
        MasterLotNum &&
        !special_chars.test(MasterLotNum) &&
        MasterLotQty &&
        mstrLotCompletionDate &&
        MasterLotQty > 0
      ) {

        if (partialShipment) {
          setNewReportBtn(true);
        }

        if (!masterQtyDisable && !broken) {
          if (sampleUnits > 0) {
            setNewReportBtn(true);
          } else {
            setNewReportBtn(false);
          }
        }
        if (timeOrdered && !broken) {
          if (subgroupSizeValidated) {
            setNewReportBtn(true);
          } else {
            setNewReportBtn(false);
          }
        }
      } else {
        setNewReportBtn(false);
      }
  }

  const onChangePONew = (PurchaseOrder) => {
    setPONum(PurchaseOrder.target.value);
    let tHeader = header;
    tHeader['PONum'] = PurchaseOrder.target.value;
    setHeader(tHeader);
  }

  const onChangePO = (PurchaseOrder) => {

    let t_po_material = [];
    if (PurchaseOrder.length > 0) {

      setPONum(PurchaseOrder[0].PONum);
      data.SupplierPO.edges.map((el) => {
        if (el.node.PONum == PurchaseOrder[0].PONum) {
          setSelectedPO(el);
          const checkMaterial = t_po_material.filter(mat => el.node.MaterialNum == mat.MaterialNum);
          if (checkMaterial.length == 0) {
            t_po_material.push({ MaterialNum: el.node.MaterialNum });
          }
        }
      });

      setPOMaterial(t_po_material);
      validateInputParams();
    } else {
      setPONum(null);
      validateInputParams();
    }
  }




  const onChangeMaterial = (MaterialNum) => {
    let t_material_rev = [];
    let t_openPO = [];
    if (MaterialNum.length > 0) {
      setPartNum(MaterialNum[0].MaterialNum);
      data.SupplierPO.edges.map((el) => {
        if (el.node.MaterialNum == MaterialNum[0].MaterialNum) {
          //  const checkPO = t_openPO.filter(po => po.PONum == el.node.PONum);

          const checkRev = t_material_rev.filter(rev => (el.node.MaterialRev == rev.MaterialRev));
          // if (checkPO.length == 0) {
          // t_openPO.push({ PONum: el.node.PONum });
          // }
          if (checkRev.length == 0) {

            if (PONum) {
              if (el.node.PONum == PONum) {
                t_material_rev.push({ MaterialRev: el.node.MaterialRev });
              }
            } else {

              t_material_rev.push({ MaterialRev: el.node.MaterialRev });
            }
          }
        }
      });
      validateInputParams();
      setMaterialRev(t_material_rev);
    } else {
      setPartNum(null);
      data.SupplierPO.edges.map((el) => {
        const checkPO = t_openPO.filter(po => po.PONum == el.node.PONum);
        if (checkPO.length == 0) {
          t_openPO.push({ PONum: el.node.PONum });
        }
      });
      t_openPO = t_openPO.sort((a, b) => parseFloat(a.PONum) - parseFloat(b.PONum));
      setOpenPO(t_openPO);
      validateInputParams();
    }
     
      
      setTimeOrdered(false);
      setPackingSlip(null);
      setSampleUnits(null);
      setSubGroupSize(null);
      setSubLotNum(null);
      setSubLotQty(null);
      
  }

  const MaterialRevChange = (MaterialRev) => {
    if (MaterialRev.length > 0) {
      let t_openPO = [];
      data.SupplierPO.edges.map((el) => {
        if (el.node.MaterialNum == PartNum && el.node.MaterialRev == MaterialRev[0].MaterialRev) {
          const checkPO = t_openPO.filter(po => po.PONum == el.node.PONum);
          if (checkPO.length == 0) {
            t_openPO.push({ PONum: el.node.PONum });
          }

        }
      });
      t_openPO = t_openPO.sort((a, b) => parseFloat(a.PONum) - parseFloat(b.PONum));
      setOpenPO(t_openPO);
      setMandatoryValidation(true);
      setAgileDocIDVer(MaterialRev[0].MaterialRev);
      // checkInspections(MaterialRev[0].MaterialRev);
      setShowValidatePlan(true);
      validatePlan(MaterialRev[0].MaterialRev);
      validateInputParams();
    } else {
      setAgileDocIDVer(null);
      validateInputParams();
    }
    setSampleUnits(null);
      setPartialShipment(false);
      setTimeOrdered(false);
      setPackingSlip(null);
      setSubGroupSize(null);
      setSubLotNum(null);
      setSubLotQty(null);
  }

  const checkInspections = () => {
    getInspections({
      variables: { VendorNum: localStorage.getItem('loggedInVendor'), PartNum: PartNum, AgileDocIDVer: AgileDocIDVer }
    });

  }

  const gfg_Run = (str) => {
    str = str.replace(/[^\x00-\x7F]/g, "");

    return str;
  }

  const checkMasterLot = (masterLot) => {
    if (inspections) {
      const checkInspections1 = inspections.filter(inspections => inspections.node.MasterLotNum.toUpperCase() == masterLot.toUpperCase());
      
      if (checkInspections1.length > 0) {
        setMasterQtyDisable(true);
        setMstrLotCompletionDate(checkInspections1[0].node.mstrLotCompletionDate);
        setMasterLotQty(checkInspections1[0].node.MasterLotQty);
        setNewReportBtn(false);
        setMeasurementsExist(false);
        setPartialShipment(true);
        document.getElementById('NewReportBtn').style.display = 'none';
      } else {
        setPartialShipment(false);
        setMasterLotQty(0);
        setMasterQtyDisable(false);
        setMstrLotCompletionDate(null);
        setMeasurementsExist(true);
        document.getElementById('NewReportBtn').style.display = 'block';
      }
      setSampleUnits(null);
      //08-24-2020 - Vasu Pabbaraju
      //Commenting the following line to fix sublot issue - JIRA - Q360-353
      // setPartialShipment(false);
      setTimeOrdered(false);
      setPackingSlip(null);
      setSubGroupSize(null);
      setSubLotNum(null);
      setSubLotQty(null);
    }
  }


  const deleteAllData = () => {
    ////console.log(details)
    let tDetails = details;
    tDetails.map((el) => {
      el.Val = '';
      el.cavityID = '';
      el.samplingTime = null;
    });
    updateInspectionCache(reportFileGUID, tDetails,'update', 'new');
    // setDetails(tDetails);
    setShowReset(false);
    setSubmitEnabled(true);

    validateAllUnits();
  }



  const changeMeasurementUpload = (measurementUpload) => {
    setMeasurementsUpload(measurementUpload);
    // if (measurementUpload) {
    //   document.getElementById('measurementsUploadyes').checked = true;
    //   document.getElementById('measurementsUploadno').checked = false;
    // } else {
    //   document.getElementById('measurementsUploadno').checked = true;
    //   document.getElementById('measurementsUploadyes').checked = false;
    // }

  }


  const changeTimeOrdered = (timeorder) => {
    setTimeOrdered(timeorder);
    if (timeorder) {

      document.getElementById('timeorderyes').checked = true;
      document.getElementById('timeorderno').checked = false;
    } else {
      setSubGroupSize('');
      document.getElementById('timeorderno').checked = true;
      document.getElementById('timeorderyes').checked = false;
    }

    validateInputParams();

  }

  const changeMeasurementsExist = (measurementsexist) => {
    setMeasurementsExist(measurementsexist);
    if (measurementsexist) {
      document.getElementById('measurementsExistyes').checked = true;
      document.getElementById('measurementsExistno').checked = false;
    } else {
      document.getElementById('measurementsExistno').checked = true;
      document.getElementById('measurementsExistyes').checked = false;
    }
    validateInputParams();
  }

  const changePartialShipment = (partialShipment) => {
    setPartialShipment(partialShipment);
    if (partialShipment) {
      document.getElementById('partialShipmentyes').checked = true;
      document.getElementById('partialShipmentno').checked = false;
    } else {
      document.getElementById('partialShipmentno').checked = true;
      document.getElementById('partialShipmentyes').checked = false;
    }
    validateInputParams();
  }


  const validatePlan = (docVer) => {

    getPlans({
      variables: {
        PartNum: PartNum,
        PartRev: docVer

      }
    });
  }

  const changeSubgroupSize = (value) => {
    if (sampleUnits && value != '') {
      if (sampleUnits % value == 0) {
        setSubGroupSize(value);
        setSubgroupsizeText('');
        setSubGroupSizeValidated(true);

      } else {
        setSubgroupsizeText('Sample size must be multiples of ' + value);
        setSubGroupSize(value);
        setSubGroupSizeValidated(false);;

        // alert('Sample size must be multiples of ' + value);
        return true;
      }
    } else {
      setSubgroupsizeText('Please enter sample size');
      setSubGroupSize(value);
      setSubGroupSizeValidated(false);
      // alert('Please enter sample size');
      return true;
    }
  }

  /*****   end of create new report helper functions */


  /**** certificate upload helper functions */



  //Delete loaded certificates function
  //This functions makes an API call to delete the file from DB as well as S3 Bucket
  const deleteFile = (fileDetail) => {
    setShowLoading(true);
    const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
    let url = window.location.origin + '/file_delete';
    if (window.location.hostname == 'localhost') {
      url = 'http://' + window.location.hostname + ':5000/file_delete';
    }

    fetch(url, {
      method: 'POST',
      body: JSON.stringify({ fileData: fileDetail }),
      headers: {
        'Content-Type': 'application/json',
        'responseType': 'application/octet-stream',
        'authorization': token || null,
        'authVendorID': localStorage.getItem('loggedInVendor')
      }
    }).then(res => {
      // FileSaver.saveAs(blob, 'Inspection_details' + fileGuid + '.xlsx');
      setShowLoading(false);
      // setShowLoader(false);
      getCertificates({ variables: { FileGUID: reportFileGUID } });
    }).catch(err => alert('Unable to download data'));

  }


  const fileHandler = (event) => {
    var sizeInMB = (event.target.files[0].size / (1024 * 1024)).toFixed(2);

    if (sizeInMB > 20) {
      alert('File size cannot be more than 20MB')
    } else {

      setCertFiles(event.target.files);
      setCertsArray([...event.target.files]);

    }

  }

  const handleFileUpload = () => {
    setCertsArray(null);
    setShowLoading(true);
    let url = window.location.origin + '/upload';
    if (window.location.hostname == 'localhost') {
      url = 'http://' + window.location.hostname + ':5000/upload';
    }
    const formData = new FormData();
    const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;

    let tHeader = header;
    if (tHeader['PartialShipmentFlag'] = false) {
      tHeader['PartialShipmentFlag'] = "0";
      tHeader['PackingSlipNum'] = '';
    } else {
      tHeader['PartialShipmentFlag'] = "1";
      tHeader['PackingSlipNum'] = '';
    }
    tHeader['SubLotNum'] = '';
    tHeader['SubLotQty'] = '';
    tHeader['Program'] = '';
    let filesLoaded = 0;
    let loadStatus = "";
    for (var i = 0; i < certFiles.length; i++) {
      const formData = new FormData();
      let file = certFiles[i];
      formData.append('files[' + i + ']', file);

      formData.append('headerObject', JSON.stringify(tHeader));
      formData.append('fileGUID', reportFileGUID);
      formData.append('vendorNum', localStorage.getItem('loggedInVendor'));
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          'authorization': token || null,
          'authVendorID': localStorage.getItem('loggedInVendor')

        }
      }

      axios.post(url, formData, config).then(function (response) {

        if (response.data.status) {
          filesLoaded++;
          if (filesLoaded == certFilesData.length) {
            setShowLoading(false);
            setShowFileUpload(false);
            getCertificates({ variables: { FileGUID: reportFileGUID } });
            validateAllUnits();
          }
        } else {


          setShowLoading(false);
          setShowFileUpload(false);
          alert('Failed to load files');
        }


      }).catch(error => {

        setShowLoading(false);
        setShowFileUpload(false);
        alert('Failed to load files, please try again');
      });
    }
    return loadStatus
  }


  const fileInput = React.createRef();

  const openFileBrowser = () => {
    fileInput.current.click();
  }

  const handleCertificates = () => {
    if (header['PONum'] == '' || !header['PONum']) {
      alert('Please select PO Before uploading files');
    } else {
      setShowFileUpload(true);
    }

  }



  const fileUploadToggle = () => setShowFileUpload(!showFileUpload);


  /******* end of file upload helper functions */

  const handleFullscreen = () => {
    document.getElementById('entryDiv').requestFullscreen();
  }



  /*** Export helper functions */
  function exportDataSumary() {
    // if (planDetails && planDetails.length > 0) {
      const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;

      header['vendorName'] = localStorage.getItem('loggedInVendorName')
      if (planDetails && planDetails.length > 0) {
      header['partDesc'] = planDetails[0].PartDesc;
      }
      header['mstrLotCompletionDate'] = moment(header['mstrLotCompletionDate']).tz('America/Los_Angeles').format('MM/DD/YYYY h:mm');
      const exportData = {
        header: header
      }

      let url = window.location.origin + '/get_summary';
      if (window.location.hostname == 'localhost') {
        url = 'http://' + window.location.hostname + ':5000/get_summary';
      }

      fetch(url, {
        method: 'POST',
        body: JSON.stringify({ file_id: reportFileGUID, exportData: exportData }),
        headers: {
          'Content-Type': 'application/json',
          'responseType': 'application/octet-stream',
          'authorization': token || null,
          'authVendorID': localStorage.getItem('loggedInVendor')
        }
      }).then(res => res.blob())
        .then(blob => {
          FileSaver.saveAs(blob, 'Shipping Summary-' + header['PartNum'] + '-'  + header['AgileDocIDVer'] + '-'  + header['MasterLotNum'] + '-'  + header['SubLotNum'] + '-'  + header['PackingSlipNum']  + '.pdf');
          // setShowLoader(false);
        }).catch(err => alert('Unable to download data'));

    // } else {
      // setPlanError(true);
    // }
  }

  function exportData() {
    if (planDetails && planDetails.length > 0) {
      const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
      header['partDesc'] = planDetails[0].PartDesc;
   
      const exportData = {
        header: header,
        detaildata: details,
        planDetails: planDetails
      }

      let url = window.location.origin + '/export_readings';
      if (window.location.hostname == 'localhost') {
        url = 'http://' + window.location.hostname + ':5000/export_readings';
      }

      fetch(url, {
        method: 'POST',
        body: JSON.stringify({ file_id: reportFileGUID, exportData: exportData }),
        headers: {
          'Content-Type': 'application/json',
          'responseType': 'application/octet-stream',
          'authorization': token || null,
          'authVendorID': localStorage.getItem('loggedInVendor')
        }
      }).then(res => res.blob())
        .then(blob => {
          FileSaver.saveAs(blob, 'Inspection-'  + header['PartNum'] + '-'  + header['AgileDocIDVer'] + '-'  + header['MasterLotNum'] + '-' +  header['PONum'] + '.xlsx');
          // setShowLoader(false);
        }).catch(err => alert('Unable to download data'));
    } else {
      setPlanError(true);
    }
  }


  const scrollRight = () => {
    const outer = document.getElementById('outercard');
    let scrollPos1 = document.getElementById('inspectionContainer').scrollLeft;
    document.getElementById('inspectionContainer').scrollLeft = scrollPos1 + Number(500);
    // setScrollPos(scrollPos1 + Number(500));
  }

  const scrollLeft = () => {
    let scrollPos1 = document.getElementById('inspectionContainer').scrollLeft;
    document.getElementById('inspectionContainer').scrollLeft = scrollPos1 - Number(500);
    // setScrollPos(scrollPos1 - Number(500));
  }

  const checkShowArrow = () => {
    if (document.getElementById('inspectionContainer')) {
      if (document.getElementById('inspectionContainer').scrollWidth > document.getElementById('inspectionContainer').offsetWidth) {
        return true;
      } else {
        return false;
      }
    }
  }

  const checkMasterLotQty = (value) => {
    if (selectedPO) {
      if (value.trim().length>0 && value > selectedPO.node.POQty) {
        setShowMasterLotQtyError(true);
        ////console.log('cannot be more than PO Quantity');
        return false;
      } else {
        setShowMasterLotQtyError(false);
      }
    }
  }

  if (header && data) {
    // let t_openPO = [];

    // data.SupplierPO.edges.map((el) => {
    //     if (el.node.MaterialNum == header.PartNum) {
    //       const checkPO = t_openPO.filter(po => po.PONum == el.node.PONum);
    //       if (checkPO.length == 0) {
    //         t_openPO.push({ PONum: el.node.PONum });
    //       }

    //     }
    //   });

    //   if (MaterialOpenPO.length ==0  && reportMode != 'Processed') {

    //     setMaterialOpenPO(t_openPO);
    //   }


  }

  const changeSampleUnits = (e) => {
    const sanitizedSampleUnitsInt = parseInt(e.target.value.replace(/[^\x00-\x7F]/g, ""))
    console.log(sanitizedSampleUnitsInt);
    console.log(MasterLotQty)
    if (sanitizedSampleUnitsInt && (sanitizedSampleUnitsInt <= MAX_SAMPLE_UNITS)) {
      //console.log(MasterLotQty);
      if (sanitizedSampleUnitsInt <= MasterLotQty) {
        setSampleUnits(sanitizedSampleUnitsInt); 
        validateInputParams();
      } else {
        alert('Sample units must be less than or equal to master lot quantity')
      }
      
    } else {
      alert(`Sample units must be less than or equal to master lot quantity, with a maximum value of ${MAX_SAMPLE_UNITS}`)
    }
    // parseInt(e.target.value.replace(/[^\x00-\x7F]/g, "")):0) <= MasterLotQty ) { setSampleUnits(e.target.value.replace(/[^\x00-\x7F]/g, "")); validateInputParams();} else {  alert('Sample units must be less than or equal to master lot quantity')} }


  }
  
  const tPONumbers = (MaterialOpenPO.length == 0) ? null : MaterialOpenPO.map((el, i) => {
    return (
      <option value={el.PONum} selected={(PONum == el.PONum) ? true : false}>{el.PONum}</option>
    )
  });

  const handleToUpdate = () => {
    getCertificates({ variables: { FileGUID: reportFileGUID } });
  }

  const processCMMFile = (ws) => {
    let processErrrors = []; //JSON Object to tag Errrors
    let processedHeaderData = []; //JSON Object to hold data
    let finalData = {};

    var range = XLSX.utils.decode_range(ws['!ref']);

    let headerRow = [];
    for (let rowNum = 0; rowNum <= 0; rowNum++) {
      for (var C = 1; C <= range.e.c; ++C) {
        let headerObject = {};
        const cell = ws[XLSX.utils.encode_cell({ r: rowNum, c: C })];
        if (cell != undefined ) {
        headerObject['feature'] = cell.w;
        headerObject['sequence'] = C;
        headerRow.push(headerObject);
        }
      }
    }


    

    headerRow.map((el,i) => {
        let measurement_values = []
        for (let rowNum = 1; rowNum <= range.e.r; rowNum++) {
          const cell = ws[XLSX.utils.encode_cell({ r: rowNum, c: i+1 })];
          if (cell && cell != undefined) {
              measurement_values.push(cell.w);
          }
          }
          el['measurement_values'] = measurement_values;
        
      });


      let tfeatureDataMapping = [];

      headerRow.map((el,i) => {
        let breakOut = false;
        planDetails.map((el1, j) => {
          if (!breakOut) {
          if (el1.SpecDataType != 'Attribute') {
            //console.log(el1.node.SpecDataType);
          let charcteristic = el1['node']['Characteristic'];
          // if (charcteristic == 'linear dimension') {
          //   charcteristic = 'distance';
          // }
         
            // if (el['cmm_feature'].toUpperCase() == el1['Label'] + "_" + charcteristic.toUpperCase() && el1['Method'].toUpperCase() == 'CMM') {
          
          if (el['feature'].toUpperCase().trim() == (el1['node']['Label'].toUpperCase() + "_" + charcteristic.toUpperCase())) {
           
            if (tfeatureDataMapping.filter(plan => plan.Label == el1['node']['Label'] && plan.Balloon == el1['node']['BaloonNum']).length == 0) { 
              tfeatureDataMapping.push({'file_column': el['feature'], 'PlanFeature': el1.node, 'foundMapping': true, 'measurement_values':el['measurement_values']});
              el['mapped'] = true;
              breakOut = true;
            } 
          }
        }
      }
        });
  
      });

      headerRow.map((el,i) => {
          if (!el.mapped) {
            tfeatureDataMapping.push({'file_column': el['feature'], 'PlanFeature': [], 'foundMapping': false, 'measurement_values':el['measurement_values']});

          }

        });
     
      
      setFeatureDataMapping(tfeatureDataMapping);
      setShowFeatureMapping(true);

   
  }

  const processFeatureDataUpload = () => {
      let tDetails = details;
       featureDataMapping.map((el,i) => {
           const featureValues = tDetails.filter(row => row['ColSlNum'] ==  el['PlanFeature']['ColSlNum']);
           //console.log(el)
            el.measurement_values.map((mval,k) => {
              if (featureValues[k]) {
                featureValues[k].Val = mval;
                featureValues[k].dirty = true;
              }
            });
         
    });
    updateInspectionCache(reportFileGUID, tDetails,'update', 'new');
    // setDetails([...tDetails]);
    validateAllUnits();
    setShowFeatureMapping(false);

  }

  const fileHandlerExcel = (event) => {
    if (event.target.files.length) {
      let fileObj = event.target.files[0];
      let fileName = fileObj.name;
      //check for file extension and pass only if it is .xlsx and display error message otherwise
      if (fileName.slice(fileName.lastIndexOf('.') + 1) === "xlsx" || fileName.slice(fileName.lastIndexOf('.') + 1) === "xls") {
        const reader = new FileReader();
        const rABS = !!reader.readAsBinaryString;
        reader.onload = (e) => {
          /* Parse data */
          const bstr = e.target.result;
          const wb = XLSX.read(bstr, { type: 'binary' });
          //////console.log(wb);
          /* Get first worksheet */
          const wsname = wb.SheetNames[0];
          const ws = wb.Sheets[wsname];
          processCMMFile(ws);
        };
        reader.readAsBinaryString(fileObj);
      }
      else {
       alert('Please upload an excel file');
      }
    }
  }

  const handleFeatureMap = (filecol,plan) => {
   
    let tfeatureDataMapping = featureDataMapping;
    tfeatureDataMapping.map((el,i) => {
        // if (el.PlanFeature.Label == plan.Label && el.PlanFeature.Method == plan.Method &&  el.PlanFeature.BaloonNum == plan.BaloonNum &&  el.PlanFeature.Characteristic == plan.Characteristic) {
          if (filecol == el.file_column) {
        el.foundMapping = false;

        }
    });
    //console.log(tfeatureDataMapping)
    setFeatureDataMapping([...tfeatureDataMapping] );
  }


  const featureMappingChange = (fileColumn, row) => {

    if (row.length>0) {
    
      let tfeatureDataMapping = featureDataMapping;
          tfeatureDataMapping.map((el,i) => {
              if (el.PlanFeature.Label == fileColumn.PlanFeature.Label && el.PlanFeature.Method == fileColumn.PlanFeature.Method &&  el.PlanFeature.BaloonNum == fileColumn.PlanFeature.BaloonNum &&  el.PlanFeature.Characteristic == fileColumn.PlanFeature.Characteristic) {
                el.foundMapping = true;
                el.PlanFeature = row[0];
                //console.log(row);
              }
          });

          setFeatureDataMapping([...tfeatureDataMapping] );

          }
  }
  if (planDetails) {
  //console.log(planDetails.filter(plan => plan.node.SpecDataType != 'Attribute'));
  }
  const featureMappingHTML = (!featureDataMapping) ? null : featureDataMapping.map((el, i) => {
    return (
    <tr><td>{el['file_column']}</td>
       {(el.foundMapping)?
     
       
       <> <td>{el.PlanFeature['Label']}</td><td>{el.PlanFeature['Method']}</td><td>{el.PlanFeature['Characteristic']}</td><td>{el.PlanFeature['BaloonNum']}</td></>
    : 
    
    <td>
    <Typeahead
    id="SuspendReason"
    labelKey="Label"
    valueKey="Label"
    options={planDetailsList.filter(plan => plan.SpecDataType != 'Attribute')}
    placeholder="Please select Feature..."
    onChange={(row) =>featureMappingChange(el,row)}
    renderMenuItemChildren={(option, props) => {
    
      return (
        <div>
          <table style={{ borderBottom: '1px solid black' }}>
            <tr><td>{option.Label}</td><td>{option.Method}</td><td>{option.Characteristic}</td><td>{option.BaloonNum}</td></tr>
          
          </table>

        </div>
      )
    }}

  /></td>
    }
     
      
      <td>
      {(el.foundMapping)? <Button onClick={() => handleFeatureMap(el.file_column,el.PlanFeature)} >Remap</Button>: null}
      </td>
      
      </tr>
    )

  });

  const getNewReportTableHeader = 
       partialShipment ? 
        <thead>
                  <tr>
                    <td> Purchase Order </td>
                    <td> Material Number</td>
                    <td> Agile Doc ID / Rev</td>
                    <td> Master Lot Number</td>
                    <td> Master Lot Quantity </td>
                    <td> Sub Lot Number </td>
                    <td> Sub Lot Quantity </td>
                    <td> Master Lot Completion Date </td>
                    <td> Packing Slip # </td>
                    {/* <td> Upload Files </td> */}
                  </tr>
                </thead>
                : 
                 <thead>
                  <tr>
                    <td> Purchase Order </td>
                    <td> Material Number</td>
                    <td> Agile Doc ID / Rev</td>
                    <td> Master Lot Number</td>
                    <td> Master Lot Quantity </td>
                    {/* <td> Sub Lot Number </td> */}
                    {/* <td> Sub Lot Quantity </td> */}
                    <td> Master Lot Completion Date </td>
                    <td> Packing Slip # </td>
                    {/* <td> Upload Files </td> */}
                  </tr>
                </thead>

  const downloadPlanTemplate = () => {
    
    const token = JSON.parse(localStorage.getItem('okta-token-storage')).accessToken.accessToken;
    const userDetails = JSON.parse(localStorage.getItem('okta-token-storage')).idToken.claims;

    const exportData = {
      header: header,
      detaildata: details,
      planDetails: planDetails,
      auditDetails: localStorage.getItem("auditDetails")
    }
  
    let url = window.location.origin + '/export_plan_template';
      
      if (window.location.hostname == 'localhost') {
        url = 'http://' + window.location.hostname + ':5000/export_plan_template';
      }
  
      fetch(url, {
        method: 'POST',
        body: JSON.stringify({ file_id: fileGuid, exportData: exportData, partNum: header.PartNum , partRev:header.AgileDocIDVer}),
        headers: {
          'Content-Type': 'application/json',
          'responseType': 'application/octet-stream',
          'authorization': token || null,
          'UserName': userDetails.name,
          'UserEmail': userDetails.email,
          'authVendorID': localStorage.getItem('loggedInVendor')
        }
      }).then(function (response) {
        if (response.ok) {
          return response;
        }
        throw new Error('Network response was not ok.');
      }).then(res => res.blob())
        .then(blob => {
          // if (data['status']) {
          //   setShowDownloadPdf(true);
            
          // }
          FileSaver.saveAs(blob, 'Plan-Template' + header.PartNum + '-' + header.AgileDocIDVer + '.xlsx');
         // setShowLoader(false);
        }).catch(err => {
          console.log(err);
         // setShowLoader(false);
          alert('Oooops!, problem downloading template');
  
        }
        );
  
  }

  const processFindPO = () => {
    // setPlanDetailsApiCompleted(false);
    // setFoundPO(false)
    clearAll()
    if (PONum) {
      setShowLoading(true);
      getPO({ variables: { PONum: PONum, VendorNum: '%'+ localStorage.getItem('loggedInVendor') } });
    }
  }

  /**
   * The Create Report button has multiple conditions that must be satisfied to enable the button. This is one of those conditions
   * If the user has decided to submit measurements, this function returns true if has slected 'yes' option in the Uploading measurements question (radio button)
   * Otherwise, this function returns false. However, if the user selects 'no' option in the Uploading measurements question (radio button), this function returns true
   * irrespective of if there is an IP available for that part/rev combination
   * @returns
   */
  const arePlanRelatedConditionsSatisfied = () => {
    return !measurementsUpload || (measurementsUpload && planDetailsExist())
  }

  const planDetailsExist = () => {
    return (planDetails && planDetails.length > 0)
  }

 const updateCertificates = (certs) => {
    setCertificates(certs);
 }

 console.log('certificates', certificates);

  /**** end of export functions */
  return (
    <Fragment>
      <Beforeunload onBeforeunload={() => "You'll lose your data!"} />

      <ReactCSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >


      <Modal
          className="modal-lg"
          style={{ width: "50%" }}
          isOpen={showCheckSubmitConfirmation}
          toggle={showCheckSubmitConfirmation}
        >
          <ModalHeader toggle={() => setShowCheckSubmitConfirmation(false)}>
            Please confirm requirements
          </ModalHeader>
          <ModalBody>
            {(certSpecs && certSpecs.length > 0 && certSpecsTable) ? certSpecsTable : null}
            
          </ModalBody>
          <ModalFooter>
            <Button
              // disabled={certFiles ? false : true}
              color="primary"
              onClick={() => handleSubmit("Processed", false)}
              disabled={!certRequirementsSatisfied}
            >
              Submit
            </Button>{" "}
            <Button color="secondary" onClick={() => setShowCheckSubmitConfirmation(false)}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>


        <Modal
          className="modal-lg"
          style={{ width: "50%" }}
          isOpen={showFileUpload}
          toggle={fileUploadToggle}
        >
          <ModalHeader toggle={fileUploadToggle}>
            Upload Certificates
          </ModalHeader>
          <ModalBody>
            <Label className="control-label required" for="exampleEmail">
              Upload Certificates
            </Label>

            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <Button
                  color="info"
                  style={{ color: "white", zIndex: 0 }}
                  onClick={openFileBrowser.bind(this)}
                >
                  <i className="cui-file"></i> Browse&hellip;
                </Button>
                <input
                  type="file"
                  hidden
                  accept=".pdf"
                  onChange={fileHandler.bind(this)}
                  ref={fileInput}
                  onClick={(event) => {
                    event.target.value = null;
                  }}
                  style={{ padding: "10px" }}
                />
              </InputGroupAddon>
              <Input type="text" className="form-control" readOnly />
            </InputGroup>
            <FormGroup>
              <FormText
                style={{
                  fontSize: "15px",
                  marginLeft: "20px",
                  color: "red !important",
                }}
              >
                Only PDF Files - Max File size 20MB
              </FormText>
            </FormGroup>
            {certFiles ? (
              <table class="table table-striped" style={{ marginTop: "20px" }}>
                <thead class="thead-dark">
                  <tr>
                    <th> New Files </th>
                  </tr>
                </thead>
                <tbody>{certFilesData}</tbody>
              </table>
            ) : null}

            {loadedFiles ? (
              <Card id="entryDiv" style={{ marginTop: "20px" }}>
                <div className="card-header">Uploaded Files</div>
                <CardBody style={{ padding: "0px" }}>
                  <table
                    class="table table-striped"
                    style={{
                      marginTop: "25px",
                      marginLeft: "15px",
                      marginRight: "15px",
                    }}
                  >
                    <thead class="thead-dark">
                      <tr>
                        <th>File Name </th>
                      </tr>
                    </thead>
                    <tbody>{loadedFiles}</tbody>
                  </table>

                  {showLoading ? (
                    <div
                      style={{
                        width: "100%",
                        textAlign: "center",
                        marginTop: "20px",
                        verticalAlign: "center",
                      }}
                    >
                      <div class="spinner-border m-5" role="status">
                        <span class="sr-only">Loading...</span>
                      </div>
                      <div
                        style={{
                          width: "100%",
                          textAlign: "center",
                          marginTop: "20px",
                          fontSize: "20px",
                        }}
                      >
                        {" "}
                        Updating .....{" "}
                      </div>
                    </div>
                  ) : null}
                </CardBody>
              </Card>
            ) : null}
          </ModalBody>
          <ModalFooter>
            <Button
              disabled={certFiles ? false : true}
              color="primary"
              onClick={handleFileUpload}
            >
              Upload
            </Button>{" "}
            <Button color="secondary" onClick={fileUploadToggle}>
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
        {/* <Navbar color="light" light expand="md">

          <NavbarBrand href="/"><img src={mainLogo} />Measurement Data Analytics</NavbarBrand>
          <div className="app-header-right">
            <UserBox />
          </div>
        </Navbar> */}
        <Breadcrumb>
          <BreadcrumbItem style={{ paddingTop: "0.5rem" }}>
            <a href="javascript:void(0);" onClick={navigateHome}>
              Home
            </a>{" "}
          </BreadcrumbItem>
          <BreadcrumbItem style={{ paddingTop: "0.5rem" }} active>
            Inspection
          </BreadcrumbItem>
          <div className="btn-actions-pane-right">
            <div role="group" className="btn-group-sm btn-group">
              <Button
                disabled={
                  packingSlip && header && header["PackingSlipNum"] != ""
                    ? false
                    : true
                }
                style={{ float: "right", marginRight: "10px" }}
                onClick={() => exportDataSumary()}
              >
                Print Summary{" "}
              </Button>
              <Button style={{ float: "right" }} onClick={() => exportData()}>
                <i class="fas fa-download fa-1x"></i>{" "}
              </Button>
            </div>
          </div>
        </Breadcrumb>
        <Nav tabs style={{ margin: "20px" }}>
          <NavItem>
            <NavLink
              className={classnames({ active: activeTab === "1" })}
              onClick={() => {
                toggle("1");
              }}
            >
              Inspection
            </NavLink>
          </NavItem>
          {reportMode != "Draft" && reportMode != "" && sampleUnits >= 12 ? (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                onClick={() => {
                  toggle("2");
                }}
              >
                Supplier Capability
              </NavLink>
            </NavItem>
          ) : null}
          {reportMode == "Draft" ||
          reportMode == "Processed" ||
          reportMode == "Submitted" ? (
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "3" })}
                onClick={() => {
                  toggle("3");

                  // reload certificates
                  getCertificates({ variables: { FileGUID: reportFileGUID } });
                }}
              >
                Certificates{" "}
                {/* {certificates ? <span>({certificates.length})</span> : null} */}
              </NavLink>
            </NavItem>
          ) : null}
        </Nav>
        <TabContent activeTab={activeTab} style={{ margin: "20px" }}>
          <TabPane tabId="1">
            {!fileGuid && data && !details && !showFinalReport && openPO ? (
              <Card className="main-card mb-3" style={{ margin: "10px" }}>
                <CardBody>
                  <Form>
                    <FormGroup row>
                    <Col sm={6}>
                        <Label for="PONum">Purchase Order</Label>
                        <Row>
                          <Col sm={4}>
                            <Input
                              id="PONum"
                              value={PONum}
                              onChange={(e) => {
                                validateAndSetPONum(e.target.value.trim())
                              }
                              }
                              placeholder="Please Enter PO Number"
                              valid={purchaseOrderNumberValid}
                              invalid={PONum!== null && !purchaseOrderNumberValid}
                            />
                          </Col>
                          <Col sm={4}>
                            <Button disabled={!purchaseOrderNumberValid} onClick={() => processFindPO()}>Find PO</Button>
                            {PONum!== null && !purchaseOrderNumberValid && <div style={{color:'red'}}>Purchase Order numbers must only contain numeric values or Invalid PO</div>}
                          </Col>
                          {foundPO &&
                            <Col sm={4}>
                            <Label
                              className="control-label required"
                              for="exampleEmail"
                            >
                              Uploading Measurement Data for inspection plan in VPI?
                            </Label>
                            <div>
                              <label
                                class="radio-inline"
                                style={{ marginLeft: "20px" }}
                              >
                                <input
                                  //disabled={!MasterLotNum ? true : false}
                                  onClick={() => changeMeasurementUpload(true)}
                                  style={{
                                    marginLeft: "-20px",
                                    position: "absolute",
                                  }}
                                  type="radio"
                                  name="uploadingMeasurements"
                                  id="uploadingMeasurementsyes"
                                  checked={measurementsUpload ? true : false}
                                />
                                Yes
                              </label>
                              <label
                                class="radio-inline"
                                style={{ marginLeft: "30px" }}
                              >
                                <input
                                  //disabled={!MasterLotNum ? true : false}
                                  onClick={() => changeMeasurementUpload(false)}
                                  style={{
                                    marginLeft: "-20px",
                                    position: "absolute",
                                  }}
                                  type="radio"
                                  name="uploadingMeasurements"
                                  id="uploadingMeasurementsno"
                                  checked={!measurementsUpload ? true : false}
                                />
                                No
                              </label>
                             
                            </div>
                            </Col>
                          }
                        </Row>
                        <Row>
                          <Col sm={12}>
                            <div style={{color: 'blue'}}>Only POs starting from 21*, 45*, 55*, 70* or 80* are allowed for submission in VPI</div>
                            <div>Note: Mismatch Revision or Open Qty issues, Contact BUYER / VPI Admin Team.</div>
                          </Col>
                        </Row>
                      </Col>
                      {/* <Col sm={2}>
                      <Label for="PONum"></Label>
                      <Button style={{paddingTop: "10px"}} onClick={() => processFindPO()}>Find PO</Button>
                      </Col> */}
                    </FormGroup>
                    {!foundPO && POData? (
                      <>
                      {!doesPOHaveMaterialsWithOpenQty() && <div style={{color: 'red', fontWeight:'bold'}}>There are no items with open quantity in the selected PO. If this is not expected, please send an email to {POData[0].node.REQUISITIONEr ? `our buyer, ${POData[0].node.REQUISITIONEr}` : 'the VPI Admin team '} and include the PO number, material number and material rev in your email.</div>}
                        <DataTable
                        title="Google Sheets-esqe"
                        columns={poColumns}
                        data={POData}
                        highlightOnHover
                        pointerOnHover
                      />
                      </>
                    ) : null}

                    {(showNoPOFoundMessage)? <div style={{color: 'red', fontWeight:'bold'}}>PURCHASE ORDER NOT FOUND. Please contact  Buyer / VPI Admin team</div>: null}
                  
                    {(foundPO)?
                 <>
                      {planDetailsApiCompleted && !arePlanRelatedConditionsSatisfied() && <div style={{color: 'red', fontWeight:'bold'}}>NO INSPECTION PLAN, Please contact VPI Admin.</div>}
                    <FormGroup row>
                    <Col sm={2}>
                        <Label className="control-label required" for="PartNum">
                          Material Number
                        </Label>
                        {(PartNum && PartNum.length > 0) ? (<b>{PartNum}</b>) : null}
                        {/* <Typeahead
                          id="PartNum"
                          labelKey="MaterialNum"
                          valueKey="MaterialNum"
                          onChange={onChangeMaterial}
                          options={POMaterial}
                          placeholder="Please select Material..."
                        /> */}
                      </Col>
                      <Col sm={2}>
                        <Label
                          className="control-label required"
                          for="AgileDocIDVer"
                        >
                          Agile Doc ID / Rev
                        </Label>
                        {(AgileDocIDVer && AgileDocIDVer.length > 0) ? (<b>{AgileDocIDVer}</b>) : null}
                        {/* <Typeahead
                          id="AgileDocIDVer"
                          labelKey="MaterialRev"
                          valueKey="MaterialRev"
                          onChange={MaterialRevChange}
                          options={MaterialRev}
                          placeholder="Please select Material..."
                        /> */}

                        {/* <Input type="select" id='AgileDocIDVer' disabled={(reportMode == 'Draft' ||reportMode == 'Submitted' || reportMode == 'Processed') ? true : false} value={AgileDocIDVer} onChange={e => { validatePlan(); setMandatoryValidation(true); setAgileDocIDVer(e.target.value); checkInspections(e.target.value); validateInputParams(); }}>
                      <option value=''>Please select Revision</option>
                      {MaterialRevSelect}

                    </Input> */}
                      </Col>
                   
                   
                    </FormGroup> 
                    <FormGroup row>
                      <Col sm={2}>
                        <Label
                          className="control-label required"
                          for="exampleEmail"
                        >
                          Master Lot Number
                        </Label>
                        <Input
                          autocomplete="off"
                          id="MasterLotNum"
                          invalid={invalidMasterLot}
                          disabled={
                            reportMode == "Draft" ||
                            reportMode == "Submitted" ||
                            reportMode == "Processed" ||
                            !mandatorValidation
                              ? true
                              : false
                          }
                          value={MasterLotNum}
                          onKeyPress={(e) => { if(!/[0-9a-zA-Z_\-]/.test(e.key)){ setInvalidMasterLot(true); e.preventDefault(); } }}
                          onChange={(e) => {
                           
                            checkMasterLot(e.target.value);
                            setMasterLotNum(e.target.value);
                            validateInputParams();
                            
                          }}
                        />
                        <FormFeedback>
                          Master lot number cannot start with leading space or special character.
                        </FormFeedback>
                        <FormText>
                          A master lot is a homogeneous group of goods that were
                          made within the same manufacturing run (equipment
                          start-up to shut-down) using the same process inputs
                          including raw materials.{" "}
                        </FormText>
                      </Col>
                      <Col sm={2}>
                        <Label
                          className="control-label required"
                          for="exampleEmail"
                        >
                          Master Lot Quantity
                        </Label>
                        <Input
                          autocomplete="off"
                          type="number"
                          invalid={showMasterLotQtyError}
                          id="MasterLotQty"
                          disabled={
                            reportMode == "Draft" ||
                            reportMode == "Submitted" ||
                            reportMode == "Processed" ||
                            !mandatorValidation ||
                            masterQtyDisable ||
                            !MasterLotNum
                              ? true
                              : false
                          }
                          value={MasterLotQty}
                          onChange={(e) => {
                            setSampleUnits(null);
                            setMasterLotQty(
                              e.target.value.replace(/[^\x00-\x7F]/g, "")
                            );
                            validateInputParams();
                          }}
                        />
                        {/* <FormFeedback style={{display: (showMasterLotQtyError)?'inline': 'none'}}>Master lot quantity cannot be more than PO Quantity 
                          {(selectedPO && selectedPO.node.POQty)? <> - {selectedPO.node.POQty}  </> : null}
                        </FormFeedback> */}
                      </Col>
                      <Col sm={2}>
                        <Label
                          className="control-label required"
                          for="exampleEmail"
                        >
                          Master Lot Completion Date
                        </Label>
                        {!masterQtyDisable ? (
                          // <Input   type="date" name="datetime" id="mstrLotCompletionDate" disabled={(reportMode == 'Draft' || reportMode == 'Submitted' || reportMode == 'Processed' || !mandatorValidation) ? true : false} value={mstrLotCompletionDate} onChange={e => {  setMstrLotCompletionDate(e.target.value); validateInputParams(); }} />
                          <Datetime
                            name="mstrLotCompletionDate"
                            disabled={!MasterLotNum ? true : false}
                            timeFormat={false}
                            input={true}
                            value={mstrLotCompletionDate}
                            inputProps={{ readOnly: true }}
                            isValidDate={compleationDateValidation}
                            onChange={(e) => {
                              changeMstrLotCompletionDate(e);
                              validateInputParams();
                            }}
                          />
                        ) : (
                          <FormText style={{ fontSize: ".78rem" }}>
                            {moment(mstrLotCompletionDate)
                              .tz("America/Los_Angeles")
                              .format("MM/DD/YYYY h:mm")}
                          </FormText>
                        )}{" "}
                        <FormText></FormText>
                      </Col>
                      <Col sm={2}>
                        <Label className="control-label" for="packingSlip">
                          Packing Slip #
                        </Label>
                        <Input
                          autocomplete="off"
                          name="packingSlip"
                          id="packingSlip"
                          disabled={
                            reportMode == "Draft" ||
                            reportMode == "Submitted" ||
                            reportMode == "Processed" ||
                            !mandatorValidation ||
                            !MasterLotNum
                              ? true
                              : false
                          }
                          value={packingSlip}
                          onChange={(e) => {
                            setPackingSlip(
                              e.target.value.replace(/[^\x00-\x7F]/g, "")
                            );
                            validateInputParams();
                          }}
                        />
                        <FormText></FormText>
                      </Col>
                    </FormGroup>
                    <FormGroup row>
                      {!masterQtyDisable ? (
                        <Col sm={2}>
                          <Label
                            className="control-label"
                            for="exampleEmail"
                          >
                            Partial Shipment?
                          </Label>
                          <div>
                            <label
                              class="radio-inline"
                              style={{ marginLeft: "20px" }}
                            >
                              <input
                                disabled={!MasterLotNum ? true : false}
                                onClick={() => changePartialShipment(true)}
                                style={{
                                  marginLeft: "-20px",
                                  position: "absolute",
                                }}
                                type="radio"
                                name="partialShipment"
                                id="partialShipmentyes"
                                checked={partialShipment ? true : false}
                              />
                              Yes
                            </label>
                            <label
                              class="radio-inline"
                              style={{ marginLeft: "30px" }}
                            >
                              <input
                                disabled={!MasterLotNum ? true : false}
                                onClick={() => changePartialShipment(false)}
                                style={{
                                  marginLeft: "-20px",
                                  position: "absolute",
                                }}
                                type="radio"
                                name="partialShipment"
                                id="partialShipmentno"
                                checked={!partialShipment ? true : false}
                              />
                              No
                            </label>
                          </div>
                        </Col>
                      ) : null}
                      {partialShipment ? (
                        <>
                          <Col sm={2}>
                            <Label className="control-label" for="exampleEmail">
                              Sub Lot Number
                            </Label>
                            <Input
                              autocomplete="off"
                              id="SubLotNum"
                              disabled={
                                reportMode == "Draft" ||
                                reportMode == "Submitted" ||
                                reportMode == "Processed" ||
                                !mandatorValidation ||
                                !MasterLotNum
                                  ? true
                                  : false
                              }
                              value={SubLotNum}
                              onKeyPress={(e) => { if(!/[0-9a-zA-Z_\-]/.test(e.key)){ e.preventDefault(); } }}
                              onChange={(e) => {
                                setSubLotNum(
                                  e.target.value.replace(/[^\x00-\x7F]/g, "")
                                );
                                validateInputParams();
                              }}
                            />
                            <FormText>
                              Sub-lots are partial shipments from a single
                              Master-Lot. The total quantity in the Sub-lots
                              must be equal to or lower than the Master Lot
                              quantity.
                            </FormText>
                          </Col>
                          <Col sm={2}>
                            <Label className="control-label" for="exampleEmail">
                              Sub Lot Quantity
                            </Label>
                            <Input
                              autocomplete="off"
                            
                              id="SubLotQty"
                              type="number"
                              disabled={
                                reportMode == "Draft" ||
                                reportMode == "Processed" ||
                                !mandatorValidation ||
                                !MasterLotNum
                                  ? true
                                  : false
                              }
                              value={SubLotQty}
                              onChange={(e) => {
                                setSubLotQty(
                                  parseInt(
                                    Number(
                                      e.target.value.replace(
                                        /[^\x00-\x7F]/g,
                                        ""
                                      )
                                    )
                                  )
                                );
                                validateInputParams();
                              }}
                            />
                          </Col>
                        </>
                      ) : null}

                      {measurementsExist ? (
                        <>
                          <Col sm={2}>
                            <Label
                              className="control-label required"
                              for="exampleEmail"
                            >
                              Sample Units
                            </Label>
                            <Input
                              max={MAX_SAMPLE_UNITS}
                              autocomplete="off"
                              id="sampleUnits"
                              type="number"
                              disabled={
                                !MasterLotQty ||
                                reportMode == "Draft" ||
                                reportMode == "Submitted" ||
                                reportMode == "Processed" ||
                                !mandatorValidation
                                  ? true
                                  : false
                              }
                              value={sampleUnits}
                              onChange={(e) => changeSampleUnits(e)}
                            />
                            <FormText>
                              Sample units must be less than or equal to master
                              lot Quantity
                            </FormText>
                          </Col>
                          <Col sm={2}>
                            <Label
                              className="control-label required"
                              for="exampleEmail"
                            >
                              Time Ordered?
                            </Label>
                            <div>
                              <label
                                class="radio-inline"
                                style={{ marginLeft: "20px" }}
                              >
                                <input
                                  disabled={!MasterLotNum ? true : false}
                                  onClick={() => changeTimeOrdered(true)}
                                  style={{
                                    marginLeft: "-20px",
                                    position: "absolute",
                                  }}
                                  type="radio"
                                  name="timeorder"
                                  id="timeorderyes"
                                  checked={timeOrdered ? true : false}
                                />
                                Yes
                              </label>
                              <label
                                class="radio-inline"
                                style={{ marginLeft: "30px" }}
                              >
                                <input
                                  disabled={!MasterLotNum ? true : false}
                                  onClick={() => changeTimeOrdered(false)}
                                  style={{
                                    marginLeft: "-20px",
                                    position: "absolute",
                                  }}
                                  type="radio"
                                  name="timeorder"
                                  id="timeorderno"
                                  checked={!timeOrdered ? true : false}
                                />
                                No
                              </label>
                              <FormText>
                                <ul>
                                  <li>
                                    <u>Time ordered data:</u> Sampled parts
                                    measurements that have production time
                                    information
                                  </li>
                                  <li>
                                    <u>Not in a time order:</u> Sampled parts
                                    measurements that do not have production
                                    time information
                                  </li>
                                </ul>
                              </FormText>
                            </div>
                          </Col>
                          {timeOrdered ? (
                            <Col sm={2}>
                              <Label
                                className="control-label required"
                                for="exampleEmail"
                              >
                                Sub Group Size?
                              </Label>
                              <div>
                                <Input
                                  autocomplete="off"
                                  id="subgroupSize"
                                  type="number"
                                  disabled={
                                    reportMode == "Draft" ||
                                    reportMode == "Submitted" ||
                                    reportMode == "Processed" ||
                                    !sampleUnits
                                      ? true
                                      : false
                                  }
                                  value={subgroupSize}
                                  onChange={(e) => {
                                    changeSubgroupSize(
                                      e.target.value.replace(
                                        /[^\x00-\x7F]/g,
                                        ""
                                      )
                                    );
                                    validateInputParams();
                                  }}
                                />
                                <FormText style={{ color: "red" }}>
                                  {subgroupsizeText}
                                </FormText>
                              </div>
                            </Col>
                          ) : null}
                        </>
                      ) : null}
                    </FormGroup>
                          
     
                    <ButtonToggle
                      id="NewReportBtn"
                      color="primary"
                      disabled={((planDetailsApiCompleted && !arePlanRelatedConditionsSatisfied()) || !newreportBtn) ? true : false}
                      onClick={createNewReport}
                      style={{
                        display:
                          reportMode == "Draft" ||
                          reportMode == "Submitted" ||
                          reportMode == "Processed"
                            ? "none"
                            : "block",
                      }}
                    >
                      Create Report
                    </ButtonToggle>
                    <ButtonToggle
                      id="NewReportBtn"
                      color="primary"
                      disabled={!newreportBtn ? true : false}
                      onClick={() =>clearAll()}
                     
                    >
                     Clear
                    </ButtonToggle>
                       </>
                       : null}
                  </Form>
                </CardBody>
              </Card>
            ) : header ? (
              <table className="align-middle mb-0 table table-borderless table-striped table-hover">
                {getNewReportTableHeader}
                <tbody>
                  <tr>
                    <td>
                     
                        {header["PONum"]}
                      
                    </td>
                    <td>{header["PartNum"]}</td>

                    <td>{header["AgileDocIDVer"]}</td>
                    <td>{header["MasterLotNum"]} </td>
                    <td>{header["MasterLotQty"]} </td>
                    {partialShipment ? (
                      <td>
                        <InputGroupAddon addonType="prepend">
                          <Input
                            disabled={reportMode != "Draft" ? true : false}
                            placeholder="Sub Lot Number"
                            name="SubLotNum"
                            id="SubLotNum"
                            value={SubLotNum}
                            onChange={(e) => {
                              setSubLotNum(e.target.value);
                              validateAllUnits();
                            }}
                          />
                        </InputGroupAddon>
                      </td>
                    ) : (
                      ""
                    )}

                    {partialShipment ? (
                      <td>
                        <InputGroupAddon addonType="prepend">
                          <Input
                            disabled={reportMode != "Draft" ? true : false}
                            placeholder="Sub Lot Quantity"
                            name="SubLotQty"
                            id="SubLotQty"
                            value={SubLotQty}
                            onChange={(e) => {
                              setSubLotQty(e.target.value);
                              validateAllUnits();
                            }}
                          />
                        </InputGroupAddon>
                      </td>
                    ) : (
                      ""
                    )}

                    {/* <td>{header['SubLotNum']} </td>
                    <td>{header['SubLotQty']} </td> */}
                    <td>
                      {moment(header["mstrLotCompletionDate"])
                        .tz("America/Los_Angeles")
                        .format("MM/DD/YYYY h:mm")}{" "}
                    </td>
                    <td>
                      <InputGroupAddon addonType="prepend">
                        <Input
                          disabled={reportMode != "Draft" ? true : false}
                          placeholder="Packing Slip #"
                          name="packingSlip"
                          id="packingSlip"
                          value={packingSlip}
                          onKeyPress={(e) => { if(!/[0-9a-zA-Z_\-]/.test(e.key)){ e.preventDefault(); } }}

                          onChange={(e) => {
                            setPackingSlip(e.target.value);
                            validateAllUnits();
                          }}
                        />
                      </InputGroupAddon>
                    </td>
                    {/* <td>
                  <InputGroup>
                  
                 <InputGroupAddon addonType="prepend">
                   <Button color="info" style={{color: "white", zIndex: 0}} onClick={openFileBrowser.bind(this)}><i className="cui-file"></i> Browse&hellip;</Button>
                   <input type="file" hidden multiple onChange={fileHandler.bind(this)} ref={fileInput} onClick={(event)=> { event.target.value = null }} style={{"padding":"10px"}} />
                 </InputGroupAddon>
                 <Input type="text" className="form-control" readOnly  />

               </InputGroup>


                </td> */}
                  </tr>
                </tbody>
              </table>
            ) : (
              <div
                style={{
                  width: "100%",
                  textAlign: "center",
                  marginTop: "20px",
                  verticalAlign: "center",
                }}
              >
                <div class="spinner-border m-5" role="status">
                  <span class="sr-only">Loading...</span>
                </div>
                <div
                  style={{
                    width: "100%",
                    textAlign: "center",
                    marginTop: "20px",
                    fontSize: "20px",
                  }}
                >
                  {" "}
                  Loading .....{" "}
                </div>
              </div>
            )}
            {showPlanDoesNotExist && !measurementsUpload ? (
              <div
                style={{
                  textAlign: "center",
                  color: "red",
                  fontWeight: "bold",
                }}
              >
                {" "}
                There is no inspection plan available for the selected Part
                Number and Revision
              </div>
            ) : null}

            {measureLotFlag == false || measurementsUpload == false || (!arePlanRelatedConditionsSatisfied())? ( //made change to show submit button even when plan does not exist
              <div>
                <ButtonToggle
                  color="primary"
                  style={{
                    marginRight: "10px",
                    display: reportMode != "Draft" ? "none" : "inline",
                  }}
                  onClick={() => handleSubmit("Draft", false)}
                >
                  Save
                </ButtonToggle>

                {header ? (
                  <ButtonToggle
                    color="primary"
                    style={{
                      marginRight: "10px",
                      display: reportMode != "Draft" ? "none" : "inline",
                    }}
                    disabled={
                      !computerVisionAPICompleted ||
                      !submitEnabled ||
                      !packingSlip ||
                      // (partialShipment && SubLotNum && SubLotQty <= 0) ||
                      // !SubLotNum ||
                      !certificates
                        ? true
                        : false
                    }
                    onClick={() => handleSubmit("Processed", false, computerVisionEnabled)}
                  >
                    Submit
                  </ButtonToggle>
                ) : (
                  <ButtonToggle
                    color="primary"
                    style={{
                      marginRight: "10px",
                      display: reportMode != "Draft" ? "none" : "inline",
                    }}
                    disabled={!submitEnabled ? true : false}
                    onClick={() => handleSubmit("Processed", false)}
                  >
                    Submit
                  </ButtonToggle>
                )}
              </div>
            ) : (
              <div>
                {tlabels &&
                tmethods &&
                tsampling &&
                tLSLUSL &&
                !showLoading &&
                setNewReportBtn &&
                t_valueRows &&
                t_valueRows.length > 0 ? (
                  <Card id="entryDiv" style={{}}>
                    <div>
                      {tlabels &&
                      tmethods &&
                      tsampling &&
                      tLSLUSL &&
                      !showLoading &&
                      setNewReportBtn &&
                      t_valueRows &&
                      t_valueRows.length > 0 ? (
                        <>
                          <div className="card-header">
                            <Progress
                              multi
                              style={{
                                backgroundColor: "transparent",
                                float: "left",
                                width: "50%",
                                height: "2rem",
                                display: reportMode != "Draft" ? "none" : "",
                              }}
                            >
                              <Progress
                                bar
                                color={
                                  packingSlip && packingSlip.length > 0
                                    ? "Success"
                                    : "danger"
                                }
                                value="15"
                              >
                                Packing Slip
                              </Progress>
                              <Progress
                                bar
                                color={
                                  certificates && certificates.length > 0
                                    ? "Success"
                                    : "danger"
                                }
                                value="15"
                              >
                                Certificates
                              </Progress>
                              {timeOrdered ? (
                                <Progress
                                  bar
                                  color={
                                    sampleTimeValidated ? "Success" : "danger"
                                  }
                                  value="15"
                                >
                                  Sample Time / Subgroups
                                </Progress>
                              ) : null}
                              <Progress
                                bar
                                color={unitsValidated ? "Success" : "danger"}
                                value="15"
                              >
                                Unit Values
                              </Progress>
                              {partialShipment ? (
                                <Progress
                                  bar
                                  color={
                                    SubLotQty > 0 &&
                                    !/^\s/.test(SubLotNum) &&
                                    SubLotNum &&
                                    SubLotNum.length != 0
                                      ? "Success"
                                      : "danger"
                                  }
                                  value="15"
                                >
                                  Sub Lot Details
                                </Progress>
                              ) : (
                                ""
                              )}
                            </Progress>

                            <div
                              className="btn-actions-pane"
                              style={{
                                display:
                                  reportMode != "Draft" ? "none" : "inline",
                              }}
                            >
                              <Button
                                style={{ marginRight: "10px" }}
                                onClick={() => downloadPlanTemplate()}
                                title="Export Plan template"
                              >
                                Plan template
                              </Button>
                            </div>
                            <div
                              class="custom-file"
                              style={{
                                marginRight: "10px",
                                width: "20%",
                                display:
                                  reportMode == "Draft" &&
                                  details &&
                                  details.length > 0
                                    ? "inline"
                                    : "none",
                              }}
                            >
                              <input
                                style={{ width: "20%" }}
                                type="file"
                                onClick={(e) => {
                                  e.target.value = "";
                                }}
                                onChange={fileHandlerExcel.bind(this)}
                                id="input"
                                class="custom-file-input"
                                id="customFile"
                              />
                              <label class="custom-file-label" for="customFile">
                                Upload Measurement file
                              </label>
                            </div>

                            {/* <div role="group" className="btn-group-sm btn-group" >
                                <div style={{ display: 'inline', marginLeft: '5px' }} class="custom-control custom-radio">
                                  <input  checked={(planTemplate == 'ISI')?true:false} id='templatetypeISI' name='templatetype1' value="ISI" type="radio" onClick={() => {console.log(planTemplate);setPlanTemplate('ISI')}} style={{  marginTop:'5px', marginLeft: '-20px', position: 'absolute' }}  />
                                  <label  class="radio-inline" >ISI Template </label>
                                </div>
                                <div style={{ display: 'inline', marginLeft: '5px' }} class="custom-control custom-radio">
                                  <input checked={(planTemplate == 'Custom')?true:false} id='templatetypeCustom'  name='templatetype1' value="Custom" type="radio"  onClick={() => {console.log(planTemplate);setPlanTemplate('Custom')}} style={{ marginTop:'5px', marginLeft: '-20px', position: 'absolute' }}  />
                                  <label class="radio-inline" >Custom Template </label>
                                </div>
                           </div> */}
                            <div
                              role="group"
                              className="btn-actions-pane-right btn-group-sm btn-group"
                            >
                              <div style={{ marginRight: "10px" }}>
                                {/* <ButtonToggle color="primary" style={{  marginRight:'10px', display: (reportMode != 'Draft') ? 'none' : 'inline' }} onClick={handleFullscreen}>Full Screen</ButtonToggle> */}
                                <ButtonToggle
                                  color="primary"
                                  style={{
                                    marginRight: "10px",
                                    display:
                                      reportMode != "Draft" ? "none" : "inline",
                                  }}
                                  onClick={() => handleReset()}
                                >
                                  Reset Data
                                </ButtonToggle>

                                {/* <ButtonToggle color="primary" style={{ marginRight: '10px', display: (reportMode != 'Draft') ? 'none' : 'inline' }} onClick={handleCertificates}>Upload Certifictes({(certificates) ? certificates.length : 0})</ButtonToggle> */}
                                <ButtonToggle
                                  color="primary"
                                  style={{
                                    marginRight: "10px",
                                    display:
                                      reportMode != "Draft" ? "none" : "inline",
                                  }}
                                  onClick={() => handleSubmit("Draft", false)}
                                >
                                  Save
                                </ButtonToggle>

                                {header ? (
                                  <ButtonToggle
                                    color="primary"
                                    style={{
                                      marginRight: "10px",
                                      display:
                                        reportMode != "Draft"
                                          ? "none"
                                          : "inline",
                                    }}
                                    disabled={
                                      !submitEnabled ||
                                      !packingSlip ||
                                      !certificates ||
                                      (partialShipment &&
                                        (!SubLotQty ||
                                          SubLotQty == 0 ||
                                          !SubLotNum ||
                                          SubLotNum == 0)) ||
                                      !PONum
                                        ? true
                                        : false
                                    }
                                    onClick={() =>
                                      handleSubmit("Processed", false)
                                    }
                                  >
                                    Submit
                                  </ButtonToggle>
                                ) : (
                                  <ButtonToggle
                                    color="primary"
                                    style={{
                                      marginRight: "10px",
                                      display:
                                        reportMode != "Draft"
                                          ? "none"
                                          : "inline",
                                    }}
                                    disabled={!submitEnabled ? true : false}
                                    onClick={() =>
                                      handleSubmit("Processed", false)
                                    }
                                  >
                                    Submit
                                  </ButtonToggle>
                                )}
                              </div>
                            </div>
                          </div>{" "}
                        </>
                      ) : null}
                    </div>
                    <CardBody id="entrycard" style={{ padding: "0px" }}>
                      <div
                        id="inspectionContainer"
                        style={{
                          maxWidth: "100%",
                          overflowY: "scroll",
                          width:
                            (planDetails.length + (timeOrdered ? 5 : 3)) * 175 +
                            "px",
                        }}
                        onPaste={(e) => handlePaste(e)}
                      >
                        <div class="header" style={{ top: 0 }}>
                          <div class="brrow">
                            {timeOrdered ? (
                              <>
                                <div class="brcol-md-3"></div>
                                <div class="brcol-md-3"></div>
                              </>
                            ) : null}
                            <div class="brcol-md-3"></div>
                            <div class="brcol-md-3"></div>
                            <div class="rcol-md-3">
                              <strong>Characteristic</strong>
                            </div>
                            {tcharacteristic}
                          </div>
                          <div class="brrow">
                            {timeOrdered ? (
                              <>
                                <div class="brcol-md-3"></div>
                                <div class="brcol-md-3"></div>
                              </>
                            ) : null}
                            <div class="brcol-md-3"></div>
                            <div class="brcol-md-3"></div>

                            <div class="rcol-md-3">
                              <strong>Label</strong>
                            </div>
                            {tlabels}
                          </div>
                          <div class="brrow">
                            {timeOrdered ? (
                              <>
                                <div class="brcol-md-3"></div>
                                <div class="brcol-md-3"></div>
                              </>
                            ) : null}
                            <div class="brcol-md-3"></div>
                            <div class="brcol-md-3"></div>

                            <div class="rcol-md-3">
                              <strong>Method</strong>
                            </div>
                            {tmethods}
                          </div>
                          <div class="brrow">
                            {timeOrdered ? (
                              <>
                                <div class="brcol-md-3"></div>
                                <div class="brcol-md-3"></div>
                              </>
                            ) : null}
                            <div class="brcol-md-3"></div>
                            <div class="brcol-md-3"></div>
                            <div class="rcol-md-3">
                              <strong>Sampling</strong>
                            </div>
                            {tsampling}
                          </div>
                          <div class="rrow">
                            <div
                              class="rcol-md-3"
                              style={{ position: "sticky", left: 0, zIndex: 1 }}
                            >
                              Unit#
                            </div>
                            {timeOrdered ? (
                              <>
                                <div class="rcol-md-3"> Sample Time</div>
                                <div class="rcol-md-3">Sub-group number</div>
                              </>
                            ) : null}

                            <div
                              class="rcol-md-3"
                              style={{ textAlign: "center" }}
                            >
                              Identifier{" "}
                              <p>
                                Ex:- Cavity ID, Serial #, Machine ID{" "}
                                <p>(Optional)</p>{" "}
                              </p>
                            </div>
                            <div class="rcol-md-3">
                              <strong>LSL - USL</strong>
                            </div>
                            {tLSLUSL}
                          </div>
                        </div>

                        <div
                          id="entryform"
                          style={{
                            float: "left",
                            height: "calc(100vh - 100px)",
                            boxSizing: "border-box;",
                          }}
                        >
                          {t_valueRows}
                        </div>
                      </div>

                      {document.getElementById("entryform") ? (
                        <>
                          <div
                            onClick={() => scrollLeft()}
                            style={{
                              display:
                                document.getElementById("entryform") &&
                                document.getElementById("entryform")
                                  .scrollLeft == 0
                                  ? "none"
                                  : "inline",
                              position: "absolute",
                              left: "1%",
                              top: "50%",
                              fontSize: "50px",
                            }}
                          >
                            <i class="fas fa-arrow-circle-left" />
                          </div>
                          <div
                            onClick={() => scrollRight()}
                            style={{
                              display: checkShowArrow() ? "inline" : "none",
                              position: "absolute",
                              right: "1%",
                              top: "50%",
                              fontSize: "50px",
                            }}
                          >
                            <i class="fas fa-arrow-circle-right" />
                          </div>
                        </>
                      ) : null}
                    </CardBody>
                  </Card>
                ) : null}{" "}
              </div>
            )}
          </TabPane>
          {(reportMode == "Submitted" || reportMode == "Processed") &&
          sampleUnits >= 12 ? (
            <TabPane tabId="2">
              {reportFileGUID &&
              PartNum &&
              AgileDocIDVer &&
              timeOrdered != null ? (
                <Capability
                  fileGuid={reportFileGUID}
                  PartNum={PartNum}
                  PartRev={AgileDocIDVer}
                  timeOrder={timeOrdered}
                  SampleUnits={sampleUnits}
                />
              ) : null}
            </TabPane>
          ) : null}

          <TabPane tabId="3">
            {header && reportFileGUID ? (
              <div>
                {!PONum ? (
                  <span>
                    Please select a PO Number before uploading certificates
                  </span>
                ) : (
                  <FileUploaderObj
                    handleToUpdate={handleToUpdate}
                    certificates={certificates}
                    updateCertificates={updateCertificates}
                    reportFileGUID={reportFileGUID}
                    header={header}
                    lots={lots}
                  />
                )}{" "}
              </div>
            ) : null}
          </TabPane>
        </TabContent>
      </ReactCSSTransitionGroup>
      <SweetAlert
        success
        show={showSaveConfirmation}
        title="Report"
        text="Successfully saved"
        onConfirm={() => setShowSaveConfirmation(false)}
      >
        {" "}
        Successfully saved
      </SweetAlert>
      <SweetAlert
        success
        show={showSubmitConfirmation}
        title="Report"
        text="Successfully Validated and Submitted"
        onConfirm={() => {
          setShowSubmitConfirmation(false);
          setShowFinalReport(true);
          if (sampleUnits > 12) {
            setActiveTab(2);
            toggle("2");
          }
          setReportMode("Submitted");

          // history.push({
          //     pathname: '/'
          //   });
        }}
      >
        Successfully Validated and Submitted
      </SweetAlert>

      <SweetAlert
        show={showReset}
        warning
        showCancel
        confirmBtnText="Yes, delete it!"
        confirmBtnBsStyle="danger"
        title="Are you sure?"
        onConfirm={() => deleteAllData()}
        onCancel={() => setShowReset(false)}
        focusCancelBtn
      >
        You will not be able to recover data!
      </SweetAlert>

      <SweetAlert
        show={planError && planDetailsApiCompleted && !arePlanRelatedConditionsSatisfied()}
        warning
        title="Validation Error"
        // confirmBtnText="Yes, delete it!"
        confirmBtnBsStyle="danger"
        title="Data Validation"
        onConfirm={() => setPlanError(false)}
        focusCancelBtn
      >
        Error Validating Plan/Data
      </SweetAlert>

      <SweetAlert
        show={showPlanChange}
        warning
        showCancel
        confirmBtnText="Yes, Download and Reset"
        confirmBtnBsStyle="danger"
        title="Inspection Plan Changed"
        onConfirm={() => DownloadAndReset(true)}
        onCancel={() => setShowPlanChange(false)}
        focusCancelBtn
      >
        Download data and reset.
      </SweetAlert>

      <Modal isOpen={showLoading} style={{ backgroundColor: "transparent" }}>
        <ModalBody>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginTop: "20px",
              verticalAlign: "center",
            }}
          >
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                verticalAlign: "center",
              }}
              class="loader"
            ></div>
            Validating Plan .....
          </div>
        </ModalBody>
      </Modal>
      {/* {showLoading ?
        <div style={{ width: '100%', textAlign: "center", marginTop: '20px', verticalAlign: 'center' }}>
          <div class="spinner-border m-5" role="status">
            <span class="sr-only">Loading...</span>
          </div>
          <div style={{ width: '100%', textAlign: "center", marginTop: '20px', fontSize: '20px' }}> Updating ..... </div>
        </div> : null} */}

      {/* <div id='loadingdiv' style={{ display: 'none', idth: '100%', textAlign: "center", marginTop: '20px', verticalAlign: 'center' }}>
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <div style={{ width: '100%', textAlign: "center", marginTop: '20px', fontSize: '20px' }}> Loadingx ..... </div>
      </div> */}

      <Modal
        isOpen={showValidatePlan}
        style={{ backgroundColor: "transparent" }}
      >
        <ModalBody>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginTop: "20px",
              verticalAlign: "center",
            }}
          >
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                verticalAlign: "center",
              }}
              class="loader"
            ></div>
            Validating Plan .....
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={showLoading} style={{ backgroundColor: "transparent" }}>
        <ModalBody>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              marginTop: "20px",
              verticalAlign: "center",
            }}
          >
            <div
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                verticalAlign: "center",
              }}
              class="loader"
            ></div>
            Processing .....
          </div>
        </ModalBody>
      </Modal>

      <Modal
        size="large"
        style={{ maxWidth: "50%" }}
        isOpen={showFeatureMapping}
        toggle={showFeatureMapping}
      >
        <ModalHeader>Feature Mapping</ModalHeader>

        <ModalBody style={{ maxHeight: "400px", overflow: "scroll" }}>
          {planTemplate == "Custom" ? (
            <>
              <Row form>
                <Col md={4}>
                  <FormGroup>
                    <Label for="exampleFile">Measurement starting Row</Label>
                    <Input
                      type="text"
                      name="rowstart"
                      id="rowstart"
                      placeholder="Measurements Starting Row"
                    />
                  </FormGroup>
                </Col>
                <Col md={4}>
                  <FormGroup>
                    <Label for="exampleFile">Measurement starting Column</Label>
                    <Input
                      type="text"
                      name="columnstart"
                      id="columnstart"
                      placeholder="Measurements Starting Column"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </>
          ) : null}
          <table class="table">
            <tr>
              <th>File Column</th>
              <th>Label</th>
              <th>Method</th>
              <th>Characteristic</th>
              <th>Balloon</th>
            </tr>
            {featureMappingHTML}
          </table>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={() => processFeatureDataUpload()}>
            Process
          </Button>{" "}
          <Button
            color="secondary"
            onClick={() => setShowFeatureMapping(false)}
          >
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

export default (withRouter(withAuth(NewReport)))